import { report360 } from '@/locales/en-US/report360';
export const assets = {
  list: {
    zonesAction: 'Zones',
    zonesTitle_one: 'Zones for {{count}} asset',
    zonesTitle_other: 'Zones for {{count}} assets',
    zonesAdd: 'Add zones',
    zonesRemove: 'Take off',
    zonesSaved_one: 'Zones saved on {{count}} asset',
    zonesSaved_other: 'Zones saved on {{count}} assets',
    zonesFailedTitle: 'Couldn\'t save the zones',
    zonesFailedBody: 'Some assets may not have changed. Check your connection and try again.',
    showMeHow: "Show me how",
    title: 'Assets',
    viewList: 'List view',
    viewCards: 'Card view',
    viewGraph: 'Network view — heatmap by health',
    viewMap: 'Map view',
    viewLabel: "View",
    subtitleOwned_one: '{{count}} asset',
    subtitleOwned_other: '{{count}} assets',
    subtitleOwnedOfLimit_one: '{{owned}} of {{count}} asset',
    subtitleOwnedOfLimit_other: '{{owned}} of {{count}} assets',
    subtitleSharedEmpty: 'Reports shared with you appear here',
    subtitleShared_one: '{{count}} asset shared with you',
    subtitleShared_other: '{{count}} assets shared with you',
    shareWithContactSubtitle: 'Share an asset with {{name}}',
    shareWithContactSubtitleNoName: 'Share an asset with this contact',
    searchPlaceholder: 'Search',
    searchA11y: 'Search assets',
    refine: 'Refine',
    refineA11y: 'Refine asset list',
    tools: 'Tools',
    addAsset: 'Add asset',
    trySample: 'Try sample',
    trySampleError: 'Could not set up the sample. Try Add asset instead.',
    addAssetA11y: 'Add new asset',
    refineSheetTitle: 'Refine assets',
    scope: 'Scope',
    groupBy: 'Group by',
    filters: 'Filters',
    pickerType: 'Asset type',
    pickerSort: 'Sort by',
    pickerHealth: 'Health score',
    pickerRelationship: 'Relationship type',
    toolsMenuTitle: 'Tools',
    selectAssets: 'Select assets',
    scanQr: 'Scan QR',
    exportAllCsv: 'Export all (CSV)',
    exportAllA11y: 'Download all visible assets as a CSV file',
    emptyNoAssetsTitle: 'No assets yet',
    emptyNoAssetsSub: "Add your first asset to start inspections and jobs on it.",
    emptyContractorSub: 'Assets your clients share with you appear here; the jobs they assign you are under Work. You can also register your own.',
    emptySharedNoneTitle: 'No shared assets yet',
    emptySharedNoneSub:
      'Assets from inspections shared with you will appear here. Open a shared report from Activity or your email link.',
    emptyScopeTitle: 'No assets in {{scope}}',
    emptyScopeSub: 'Change the scope filter or add assets to this team.',
    emptyFilterTitle: 'No matching assets',
    emptyFilterSub: 'Try different search terms or clear filters.',
    clearFilters: 'Clear filters',
    webViewerEmptyTitle: 'No row selected',
    webViewerEmptySub: 'Select an asset in the list to open the tabbed viewer below.',
    workspaceInsightSummary:
      '{{total}} in view · {{poor}} poor health · {{watch}} watch · {{good}} good · {{unscored}} not yet scored',
    operationalInsight: {
      insightPanelTitle: 'Register insight',
      insightSourceExisting: 'Existing asset health bands',
      summaryLine:
        '{{total}} assets · {{poor}} poor health · {{watch}} watch · {{good}} good · {{unscored}} without a score',
      poorExplanation_one: '{{count}} asset scores 40 or below on health.',
      poorExplanation_other: '{{count}} assets score 40 or below on health.',
      poorRecommended: 'Prioritise inspections, jobs, and documents dragging those scores.',
      poorCta: 'Filter poor health',
      watchExplanation_one: '{{count}} asset is in the watch band (41–70).',
      watchExplanation_other: '{{count}} assets are in the watch band (41–70).',
      watchRecommended: 'Plan inspections or remediation before they slip into poor health.',
      watchCta: 'Filter watch band',
      unscoredExplanation_one: '{{count}} asset does not have a health score yet.',
      unscoredExplanation_other: '{{count}} assets do not have a health score yet.',
      unscoredRecommended: 'Complete profile details and run inspections so scoring can apply.',
      unscoredCta: 'Open refine',
      balancedExplanation: 'No assets in this view are in poor health or the watch band.',
      balancedRecommended: 'Keep inspections and jobs current to hold steady scores.',
      refineCta: 'Refine list',
      exportCsvLabel: 'Export visible assets (CSV)',
    },
    cancel: 'Cancel',
    selected_one: '{{count}} selected',
    selected_other: '{{count}} selected',
    clearVisible: 'Clear visible',
    allVisible: 'All visible',
    exportCsv: 'Export CSV',
    bulkExportA11y: 'Export selected assets as CSV',
    bulkSelectAllA11y: 'Select all visible assets',
    bulkDeselectAllA11y: 'Deselect all visible assets',
    printLabels: 'Print labels',
    assignTeam: 'Assign team',
    assignToTeam: 'Assign to team',
    personal: 'Personal',
    unknownTeam: 'Unknown team',
    qrPrintTitle: 'Print labels for selected assets',
    exportNoSelectionTitle: 'No assets selected',
    exportNoSelectionBody: 'Select at least one visible asset to export.',
    exportCopiedTitle: 'Export copied',
    exportCopiedBody_one: 'Copied {{count}} asset row as CSV.',
    exportCopiedBody_other: 'Copied {{count}} asset rows as CSV.',
    exportErrorTitle: 'Error',
    exportErrorBody: 'Failed to update assets.',
    typeChip: 'Type',
    sortChip: 'Sort',
    healthChip: 'Health',
    relationshipChip: 'Relationship',
    typeAll: 'All types',
    typeCar: 'Vehicle',
    typeProperty: 'Place',
    typeEquipment: 'Equipment',
    typeOther: 'Other',
    kindAll: 'All',
    kindPlaces: 'Places',
    kindEquipment: 'Equipment',
    kindVehicles: 'Vehicles',
    sortNewest: 'Newest first',
    sortOldest: 'Oldest first',
    sortNameAsc: 'Name A–Z',
    sortNameDesc: 'Name Z–A',
    sortLastInspected: 'Last inspected',
    sortMostInspections: 'Most inspections',
    healthAny: 'Any health score',
    healthLt80: 'Score below 80',
    healthLt60: 'Score below 60',
    relationshipAll: 'Any relationship',
    groupType: 'Type',
    groupTeam: 'Team',
    viewActivity: 'View Activity',
    signalNoInspection: 'No inspection',
    signalNoData: 'No data',
    loadingMore: 'Loading more…',
    endOfList_one: '{{count}} asset — that’s everything',
    endOfList_other: '{{count}} assets — that’s everything',
    endOfListInView_one: '{{count}} asset in this view',
    endOfListInView_other: '{{count}} assets in this view',
    signalScore: 'Score {{score}}',
    signalNoHealthScore: 'No health score',
    signalRisk: '{{level}} risk',
    signalNoRisk: 'No risk score',
    signalNotScored: 'Not scored',
    healthGood: 'Good',
    healthWatch: 'Watch',
    healthPoor: 'Poor',
    riskLow: 'Low',
    riskMedium: 'Medium',
    riskHigh: 'High',
    riskExtreme: 'Extreme',
    csvHeaderAsset: 'Asset',
    csvHeaderType: 'Type',
    csvHeaderHealthStatus: 'Health status',
    csvHeaderHealthScore: 'Health score',
    csvHeaderRisk: 'Risk',
    csvHeaderRiskScore: 'Risk score',
    csvHeaderOpenJobs: 'Open jobs',
    csvHeaderOverdueJobs: 'Overdue jobs',
    csvHeaderLastInspection: 'Last inspection',
    csvHeaderCreated: 'Created',
    csvExportName: 'Name',
    csvExportType: 'Type',
    csvExportTeam: 'Team',
    csvExportCreated: 'Created',
    csvExportUpdated: 'Updated',
    insightStripTitle: 'Health insight',
    healthStatusHeadline: '{{critical}} critical · {{warning}} on watch',
    healthStatusSecondary: '{{good}} in good health · {{unscored}} unscored',
    queueAttention: 'Needs attention',
    queueAll: 'All',
    queueShared: 'Shared',
    queueTablistA11y: 'Asset list view',
    inspectPriority: 'Inspect priority',
    inspectPriorityA11y: 'Open the highest-priority asset that needs attention',
    advancedFiltersTitle: 'Advanced filters & sorting',
    advancedFiltersSummary_one: '{{count}} refinement active',
    advancedFiltersSummary_other: '{{count}} refinements active',
    advancedFiltersSummaryEmpty: 'Type, health, sort, grouping, scope',
    advancedFiltersExpand: 'Show filters',
    advancedFiltersCollapse: 'Hide filters',
    emptyAttentionClearTitle: 'Nothing needs attention',
    emptyAttentionClearSub: 'All assets in this scope are in good health or unscored.',
    emptyAttentionShowAll: 'Show all assets',
    emptySharedTitle: 'Nothing shared with you',
    emptySharedSub: 'Assets another workspace shares with you appear here.',
    moreActions: "More actions",
    queueRetired: "Retired",
  },
  contacts: {
    emptyTitle: 'No contacts linked yet',
    emptyDescription:
      'Link owners, tenants, contractors, or managers — then share access at the same time.',
    /**
     * The Contacts badge counts linked contacts PLUS report recipients, but the
     * list below only renders links. With links at zero and a recipient on file
     * the badge said "1" over a "no contacts" body, so the empty state has to
     * account for the people the badge is counting.
     */
    emptyWithRecipients_one:
      '{{count}} person has received a report for this asset but is not linked yet. Link them to keep the relationship on the asset.',
    emptyWithRecipients_other:
      '{{count}} people have received reports for this asset but are not linked yet. Link them to keep the relationship on the asset.',
    linkContact: 'Link contact',
    reportRecipients: 'Report recipients',
    recipientCount_one: '{{count}} recipient',
    recipientCount_other: '{{count}} recipients',
  },
  shared: {
    contactRelationship: {
      other: "Other",
      manager: "Manager",
      occupant: "Occupant",
      site_contact: "Contact on site",
      reviewer: "Reviews work",
      approver: "Approves work",
      observer: "Kept informed",
      supplier: "Supplier",
      contractor: "Contractor",
      client: "Client",
      landlord: "Landlord",
      tenant: "Tenant",
      owner: "Owner",
      recipient: "Gets reports",
      requester: "Reports problems",
      assignee: "Does the work",
    },
    disposalMethod: {
      other: "Other",
      donated: "Donated",
      transferred: "Transferred",
      returned: "Returned to the lender",
      recycled: "Recycled",
      scrapped: "Scrapped",
      sold: "Sold",
    },
    retirementReason: {
      other: "Other",
      lost: "Lost or stolen",
      replaced: "Replaced",
      decommissioned: "Taken out of service",
      disposed: "Thrown away",
      sold: "Sold",
    },
    decommissionReason: {
      other: "Other",
      relocated: "Moved elsewhere",
      seasonal: "Seasonal shutdown",
      replaced: "Replaced",
      fault: "Fault",
      end_of_life: "End of life",
    },
    standing: {
      active: "Active",
      retired: "Retired",
      archived: "Archived",
      decommissioned: "Out of service",
      planned: "Not yet in service",
      in_service: "In service",
    },
    complianceTag: {
      warranty_active: "Under warranty",
      insurance_required: "Insurance required",
      ppe: "Protective equipment",
      pressure_system: "Pressure system",
      lifting_equipment: "Lifting equipment",
      vehicle_roadworthy: "Roadworthy vehicle",
      energy_performance: "Energy performance (EPC)",
      water_hygiene: "Water hygiene",
      gas_safety: "Gas safety",
      electrical_safety: "Electrical safety",
      fire_safety: "Fire safety",
    },
    operatingContext: {
      operational: "Day-to-day operations",
      storage: "Storage",
      shared_use: "Shared use",
      staff_only: "Staff only",
      customer_facing: "Used by customers",
    },
    lifecycle: {
      decommissioned: "Out of service",
      under_renovation: "Being renovated",
      partially_operational: "Partly in service",
      operational: "In service",
      handover: "Being handed over",
      partially_developed: "Partly built",
      in_development: "Being built",
      planned: "Planned",
    },
    otherDomain: {
      other: "Other",
      miscellaneous: "Miscellaneous",
      storage: "Storage",
      fixture: "Fixture",
      inventory: "Stock",
      signage: "Signs",
      it: "IT equipment",
      furniture: "Furniture",
    },
    installation: {
      vehicle_mounted: "On a vehicle",
      portable: "Portable",
      fixed: "Fixed in place",
    },
    powerSource: {
      pneumatic: "Air-powered",
      hydraulic: "Hydraulic",
      manual: "Manual",
      gas: "Gas",
      petrol: "Petrol",
      diesel: "Diesel",
      battery: "Battery",
      electric: "Electric",
    },
    equipmentClass: {
      other: "Other",
      kitchen_equipment: "Kitchen equipment",
      appliance: "Appliance",
      electrical_distribution: "Electrical distribution",
      fire_system: "Fire system",
      safety_equipment: "Safety equipment",
      cleaning_machine: "Cleaning machine",
      machine: "Machine",
      power_tool: "Power tool",
      lift: "Lift",
      compressor: "Compressor",
      forklift: "Forklift",
      pump: "Pump",
      generator: "Generator",
      boiler: "Boiler",
      hvac: "Heating and cooling",
    },
    vehicleUsage: {
      plant_support: "Supports machinery",
      site_use: "On-site use",
      passenger_transport: "Passenger transport",
      delivery: "Delivery",
      fleet: "Fleet",
      personal: "Personal",
    },
    vehicleFuel: {
      other: "Other",
      lpg: "LPG",
      electric: "Electric",
      hybrid: "Hybrid",
      diesel: "Diesel",
      petrol: "Petrol",
    },
    vehicleClass: {
      other: "Other",
      plant_vehicle: "Construction vehicle",
      bus: "Bus",
      motorcycle: "Motorcycle",
      trailer: "Trailer",
      truck: "Truck",
      van: "Van",
      car: "Car",
    },
    occupancy: {
      new_build: "New build",
      under_renovation: "Being renovated",
      partially_occupied: "Partly occupied",
      vacant: "Empty",
      occupied: "Occupied",
    },
    propertySubtype: {
      other: "Other",
      depot: "Depot",
      plant: "Plant",
      yard: "Yard",
      workshop: "Workshop",
      factory: "Factory",
      warehouse: "Warehouse",
      mixed_use: "Mixed use",
      education: "School or college",
      healthcare: "Healthcare",
      hospitality: "Hotel or restaurant",
      retail: "Shop",
      office: "Office",
      holiday_rental: "Holiday rental",
      student_accommodation: "Student accommodation",
      studio: "Studio",
      townhouse: "Townhouse",
      flat: "Flat",
      apartment: "Apartment",
      house: "House",
    },
    assetType: {
      car: 'Vehicle',
      property: 'Place',
      equipment: 'Equipment',
      other: 'Other',
    },
    externalIdType: {
      vin: 'VIN',
      serial: 'Serial number',
      registration: 'Registration',
      barcode: 'Barcode',
      custom: 'Custom ID',
    },
    documentType: {
      certificate: 'Certificate',
      warranty: 'Warranty',
      compliance: 'Compliance',
      general: 'General',
    },
    criticality: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
    },
    mobility: {
      fixed: 'Fixed',
      movable: 'Movable',
      mobile: 'Mobile',
    },
    propertyFamily: {
      residential: 'Residential',
      commercial: 'Commercial',
      industrial: 'Industrial',
    },
    furnishedStatus: {
      unfurnished: 'Unfurnished',
      part_furnished: 'Part furnished',
      fully_furnished: 'Fully furnished',
    },
    propertySystem: {
      hvac: 'HVAC',
      electrical: 'Electrical',
      plumbing: 'Plumbing',
      fire_alarm: 'Fire alarm',
      sprinklers: 'Sprinklers',
      security_alarm: 'Security alarm',
      access_control: 'Access control',
      cctv: 'CCTV',
      lift: 'Lift',
      solar: 'Solar',
    },
    vehicleTransmission: {
      manual: 'Manual',
      automatic: 'Automatic',
      semi_automatic: 'Semi-automatic',
    },
    vehicleConditionFlag: {
      road_legal: 'Road legal',
      insured: 'Insured',
      under_warranty: 'Under warranty',
      service_contract: 'Service contract',
      high_mileage: 'High mileage',
      off_road_use: 'Off-road use',
    },
    equipmentConditionFlag: {
      service_contract: 'Service contract',
      under_warranty: 'Under warranty',
      calibration_required: 'Calibration required',
      inspection_required: 'Inspection required',
      safety_critical: 'Safety critical',
    },
    /** Unit codes (kW, kVA, kg, PSI, CFM, BTU) read the same everywhere and fall back to the code. */
    equipmentCapacityUnit: {
      litres: 'Litres',
      tonnes: 'Tonnes',
      other: 'Other',
    },
    equipmentSafetyClass: {
      general: 'General',
      safety_critical: 'Safety critical',
      lifting: 'Lifting',
      pressure: 'Pressure',
      electrical: 'Electrical',
      fire_safety: 'Fire safety',
    },
    equipmentOperatingEnvironment: {
      indoor: 'Indoor',
      outdoor: 'Outdoor',
      mixed: 'Mixed',
      wet_area: 'Wet area',
      dusty: 'Dusty',
      high_temperature: 'High temperature',
      cold_environment: 'Cold environment',
    },
    otherRiskTag: {
      fragile: 'Fragile',
      high_value: 'High value',
      regulated: 'Regulated',
      public_facing: 'Public facing',
      portable: 'Portable',
      safety_critical: 'Safety critical',
    },
    otherMiscKind: {
      general: 'General / uncategorised',
      documentation: 'Documentation & records',
      consumables: 'Consumables',
      spare_parts: 'Spare parts',
      tooling: 'Tools & equipment',
      display_marketing: 'Display & marketing',
      safety_supplies: 'Safety supplies',
      mixed_stock: 'Mixed stock',
    },
    compliancePosture: {
      clear: 'Clear',
      watch: 'Watch',
      action: 'Action',
    },
    externalIdPlaceholder: {
      vin: 'e.g. 1HGBH41JXMN109186',
      serial: 'e.g. SN-2024-00123',
      registration: 'e.g. ABC 1234',
      barcode: 'e.g. scan or enter barcode / QR value',
      custom: 'Enter custom reference...',
    },
  },
  documents: {
    add: {
      editHint: "Change the dates, reminder, title or notes, then tap Save document. The file stays as it is.",
      editTitle: "Edit document details",
      pickTitle: 'Add document',
      pickBody: 'Choose how you want to attach the document.',
      labels: {
        validMonths: "Valid {{months}} months",
        subtype: "Kind of document",
        referenceNumber: 'Certificate / reference number',
        documentType: 'Document type',
        title: 'Title',
        file: 'File',
        issueDate: 'Issue date',
        expiryDate: 'Expiry date',
        reminderDays: "Remind me this many days before it expires",
        notes: 'Notes',
        validator: "Who checks and approves it?",
        validatorHint: "They get a notification and a task until they approve or reject it.",
        validatorNoTeam: 'This asset has no managing team yet, so validation stays with you.',
        validatorMe: 'Me',
        validatorApprover: 'Asset approver',
      },
      placeholders: {
        referenceNumber: 'e.g. ABC123456 (optional)',
        title: 'e.g. Gas safety certificate',
        titleRenewed: 'Renewed certificate',
        file: 'Choose a file to upload',
        issueDate: 'YYYY-MM-DD',
        expiryDate: 'YYYY-MM-DD',
        notes: 'Private notes about this document',
      },
      a11y: {
        saveDocument: 'Save document',
      },
      actions: {
        saving: 'Saving...',
        submit: 'Save document',
      },
      ai: {
        title: 'AI document details',
        suggestAction: 'Suggest details with AI',
        prompt: 'Extract title, type, and dates from the uploaded file when you are online.',
        reviewHint: 'Review suggested fields before saving. Certificates still require validation.',
        applyAll: 'Apply all suggestions',
        providerName: 'Provider / issuer',
        assetIdentifier: 'Asset identifier on document',
      },
      alerts: {
        photoPermission: 'Allow photo library access to choose a document image.',
        cameraPermission: 'Allow camera access to capture a document.',
        documentPicker: 'Unable to open the file picker.',
        assetNotFound: 'Asset not found.',
        titleRequired: 'Enter a document title.',
        fileRequired: 'Choose a file to upload.',
        signInRequired: 'Sign in again before saving this document.',
        saveFailed: 'Unable to save this document.',
      },
      energy: {
        scheme: "Certificate",
        schemeEPC: "EPC",
        schemeDEC: "DEC",
        rating: "Rating",
        score: "Score",
        scorePlaceholder: "e.g. 68",
        isLet: "The building is let",
        isLetHint: "A let building in England and Wales needs E or better.",
        belowMinimum: "Below E: this building cannot be let at this rating without an exemption.",
        ratingRequired: "Choose the rating from the certificate.",
      },
    },
  },
  relationships: {
    alerts: {
      duplicateCheckFailedTitle: "Couldn’t check for duplicates",
      markDistinct: "No, they are different",
      markDuplicate: "Yes, mark as possible duplicate",
      duplicateFoundBody: "{{name}} looks like this asset. Is it the same one?",
      duplicateFoundTitle: "This might be the same asset",
      noDuplicatesBody: "No other asset matches this one.",
      noDuplicatesTitle: "No duplicates found",
      mergeFailedTitle: "Couldn’t merge",
      merge: "Merge",
      mergeBody: "This asset is marked as merged. Its history is kept.",
      mergeTitle: "Merge into the other record?",
      canonicalFailedTitle: "Couldn’t mark the main record",
      removeFailedTitle: "Couldn’t remove the link",
      remove: "Remove",
      cancel: "Cancel",
      removeBody: "Both assets stay. Only the link between them is removed.",
      removeTitle: "Remove this link?",
      tryAgain: "Check your connection and try again.",
      updateFailedTitle: "Couldn’t save the link",
      addFailedTitle: "Couldn’t add the link",
      selectAssetBody: "Search for the asset to link, then tap it.",
      selectAssetTitle: "Pick an asset",
    },
    views: { list: 'List', tree: 'Tree', map: 'Map' },
    refine: 'Refine',
    refineA11y: 'Refine map',
    refineTitle: 'Refine map',
    refineShow: 'Show',
    refineRisk: 'Risk',
    refineCriticality: 'Criticality',
    refineDepth: 'Depth',
    refineColour: 'Colour by',
    refineLayout: 'Layout',
    filter: { all: 'All', hierarchy: 'Hierarchy', dependency: 'Dependency', association: 'Association', duplicate: 'Duplicate', inbound: 'Inbound', outbound: 'Outbound' },
    riskOnly: 'Risk-relevant only',
    highlightCritical: 'Highlight critical',
    hops_one: '{{count}} hop',
    hops_other: '{{count}} hops',
    colour: { combined: 'All', health: 'Health', type: 'Type', risk: 'Link category' },
    layout: { auto: 'Auto', hierarchy: 'Hierarchy', force: 'Network', radial: 'Radial', grid: 'Grid' },
    groups: { parents: 'Parents / containers', children: 'Children / contained', dependsOn: 'Depends on', supports: 'Supports / affects', related: 'Related', canonical: 'Main record', duplicates: 'Possible duplicates' },
    emptyTitle: 'No relationships defined yet',
    emptyBody: 'Link a parent, component, or peer asset so dependencies and impact are known.',
    linkAsset: 'Link asset',
    linkAssetA11y: 'Link an asset',
    checkDuplicates: 'Check duplicates',
    checkDuplicatesA11y: 'Check for duplicate assets',
    setCanonical: 'Make this the main record',
    merge: 'Merge',
    compare: 'Compare',
    comparison: 'Comparison',
    loadingGraph: 'Loading graph...',
    mapAssets_one: '{{count}} asset',
    mapAssets_other: '{{count}} assets',
    mapLinks_one: '{{count}} link',
    mapLinks_other: '{{count}} links',
    mapImpacts_one: 'impacts {{count}} related from here',
    mapImpacts_other: 'impacts {{count}} related from here',
    openAsset: 'Open {{name}}',
    editLink: 'Edit link to {{name}}',
    unlink: 'Unlink {{name}}',
    treeLoading: 'Loading…',
    treeThisAsset: 'This asset',
    treeChildren_one: '{{count}} child',
    treeChildren_other: '{{count}} children',
    riskRelevant: 'Risk-relevant',
    informational: 'Informational',
    linkCreated: 'Link created',
    linkAnother: 'Link another',
    done: 'Done',
    type: {
      contains: 'Contains',
      part_of: 'Part of',
      located_in: 'Located in',
      depends_on: 'Depends on',
      supports: 'Supports',
      connected_to: 'Connected to',
      serves: 'Serves',
      powered_by: 'Powered by',
      monitored_by: 'Monitored by',
      associated_with: 'Associated with',
      backup_for: 'Backup for',
      replacement_for: 'Replacement for',
      assigned_to: 'Assigned to',
      installed_in: 'Installed in',
      maintained_with: 'Maintained with',
      possible_duplicate_of: 'Possible duplicate of',
      duplicate_of: 'Duplicate of',
      merged_into: 'Merged into',
    },
    verb: {
      contains: 'contains',
      part_of: 'is part of',
      located_in: 'is located in',
      depends_on: 'depends on',
      supports: 'supports',
      connected_to: 'is connected to',
      serves: 'serves',
      powered_by: 'is powered by',
      monitored_by: 'is monitored by',
      associated_with: 'is associated with',
      backup_for: 'is a backup for',
      replacement_for: 'is a replacement for',
      assigned_to: 'is assigned to',
      installed_in: 'is installed in',
      maintained_with: 'is maintained with',
      possible_duplicate_of: 'may be a duplicate of',
      duplicate_of: 'is a duplicate of',
      merged_into: 'was merged into',
    },
    category: { hierarchy: 'Hierarchy', dependency: 'Dependencies', association: 'Related', duplicate: 'Duplicates' },
    propagation: { none: 'None', informational: 'Informational', contributes_to_parent: 'Contributes to parent', contributes_to_dependent: 'Contributes to dependent', bidirectional_warning: 'Bidirectional warning' },
    form: {
      addTitle: 'Add relationship',
      editTitle: 'Edit relationship',
      close: 'Close',
      relatedAsset: 'Related asset',
      chooseRelated: 'Choose the asset this one relates to',
      choose: 'Choose',
      change: 'Change',
      done: 'Done',
      edit: 'Edit',
      relationshipType: 'Relationship type',
      swap: 'Swap',
      swapA11y: 'Swap direction',
      riskAndNotes: 'Risk & notes',
      criticality: 'Criticality',
      countsTowardsRisk: 'Counts towards risk',
      riskRelevant: 'Risk-relevant',
      informationalOnly: 'Informational only',
      informationalHint: '{{type}} relationships are informational.',
      propagation: 'Risk propagation',
      reasonPlaceholder: 'Criticality reason (optional)',
      reasonA11y: 'Criticality reason',
      notesPlaceholder: 'Notes (optional)',
      notesA11y: 'Notes',
      notes: 'Notes',
      cancel: 'Cancel',
      add: 'Add relationship',
      save: 'Save changes',
      saving: 'Saving...',
      and: '{{a}} and {{b}}',
      selectAssetTitle: 'Select asset',
      selectAssetBody: 'Choose an asset to relate.',
      couldNotAdd: 'Could not add relationship',
      tryAgain: 'Please try again.',
    },
    edge: { added: 'Added {{date}}', edit: 'Edit', remove: 'Remove', close: 'Close' },
    picker: {
      addAsset: "Add an asset",
      title: 'Asset',
      relatedTitle: 'Related asset',
      searchPlaceholder: 'Search by name, site or ID…',
      searchA11y: 'Search assets',
      clearSearch: 'Clear search',
      allTypes: 'All types',
      searching: 'Searching all assets…',
      noneYet: 'No assets yet.',
      noMatchHint: 'No assets match. Try another name, or clear the type filter.',
      noMatch: 'No assets match.',
      showingFirst: 'Showing the first {{shown}} of {{total}}. Keep typing to narrow.',
      noAsset: 'No asset',
      clearSelection: 'Clear selection',
      done: 'Done',
      close: 'Close',
      chooseAsset: 'Choose an asset',
      changeA11y: 'Asset: {{name}}. Change',
    },
  },
  relationshipNode: {
    current: 'Current asset',
    unscored: 'Health unscored',
    loadingImpact: 'Loading impact…',
    impacts_one: 'Impacts {{count}} related asset',
    impacts_other: 'Impacts {{count}} related assets',
    open: 'Open asset',
    addRelationship: 'Add relationship',
    viewWork: 'View impacted work',
    close: 'Close',
  },
  documentsSection: {
    editDetails: "Edit details",
    statusAll: 'All',
    statusExpired: 'Expired',
    statusExpiringSoon: 'Expiring soon',
    statusValid: 'Valid',
    statusPending: 'Pending',
    statusRejected: 'Rejected',
    statusSupersededOrUndated: 'Superseded or undated',
    typeAll: 'All types',
    typeCertificates: 'Certificates',
    typeWarranty: 'Warranty',
    typeCompliance: 'Compliance',
    typeGeneral: 'General',
    viewList: 'List',
    viewTimeline: 'Timeline',
    viewCalendar: 'Calendar',
    viewLabel: "View",
    loadingDocumentsA11y: 'Loading documents',
    loadingDocumentsText: 'Loading documents…',
    addDocumentA11y: 'Add document',
    tryLoadingAgainA11y: 'Try loading documents again',
    refineDocumentsA11y: 'Refine documents',
    searchDocumentsA11y: 'Search documents',
    clearSearchA11y: 'Clear search',
    refineDocumentsTitle: 'Refine documents',
    rejectionReasonA11y: 'Rejection reason',
    reasonPlaceholder: 'Reason',
    validateInTheirPlace: 'Validate in their place',
    openFile: 'Open file',
    validate: 'Validate',
    renew: 'Renew',
    replace: 'Replace',
    reject: 'Reject',
    startInspection: 'Start inspection',
    createJob: 'Create job',
    planRenewal: "Plan its renewal",
    history: 'History',
    closeA11y: 'Close',
    metaIssued: 'Issued',
    metaExpires: 'Expires',
    metaReminder: 'Reminder',
    metaReminderDays: '{{days}} days',
    metaSource: 'Source',
    metaFile: 'File',
    metaValidatedBy: 'Validated by',
    metaPrevious: 'Previous',
    metaNext: 'Next',
    showPreviousMonthA11y: 'Show previous month',
    showNextMonthA11y: 'Show next month',
    showTodayA11y: 'Show today',
    dateHintA11y: 'Shows the documents issued or expiring on this date',
    documentHistoryTitle: 'Document history',
    noRenewalHistory: 'No renewal history yet.',
    historyEntry: '{{index}}. {{title}} - {{date}} - {{status}}',
    historyCurrentStatus: 'current',
    validateDocumentTitle: 'Validate document',
    validateDocumentBody: 'Validate "{{title}}" and mark it as active?',
    cancel: 'Cancel',
    reasonRequiredTitle: 'Reason required',
    reasonRequiredBody: 'Enter a rejection reason before rejecting this document.',
    pageTitle: 'Documents',
    pageSub: 'Files, certificates, and warranties stored against this asset.',
    loadErrorText: 'Couldn’t load documents',
    emptyText: 'No documents yet',
    emptySub: 'Certificates, warranties and manuals for this asset live here, with their expiry dates tracked.',
    tryAgain: 'Try again',
    addDocumentButton: 'Add Document',
    viewOptionA11y: '{{label}} view',
    refine: 'Refine',
    searchPlaceholder: 'Search documents…',
    rejectDocumentTitle: 'Reject document',
    rejectDocumentBody: 'Enter the reason this document cannot be validated.',
    openDocumentA11y: 'Open {{title}}',
    rejectionReasonPrefix: 'Rejection reason: {{reason}}',
    noDocumentDates: 'No document dates',
    documentDateCount_one: '{{count}} document date',
    documentDateCount_other: '{{count}} document dates',
    dayCellA11y: '{{dateLabel}}. {{eventLabel}}.',
    statusPendingValidation: 'Pending validation',
    statusSupersededLabel: 'Superseded',
    statusNoExpiryRecorded: 'No expiry recorded',
    statusEvidenceMissing: 'Evidence missing',
    kindIssued: 'Issued',
    kindAdded: 'Added',
    kindExpires: 'Expires',
    openDocumentWithStatusA11y: 'Open {{title}}. {{status}}.',
    issuedOn: 'Issued {{date}}',
    addedOn: 'Added {{date}}',
    expiresOnSuffix: ' · Expires {{date}}',
    noExpiryRecordedSuffix: ' · No expiry recorded',
    expiresLowerSuffix: ' → expires {{date}}',
    noExpiryRecordedLowerSuffix: ' · no expiry recorded',
    today: 'Today',
  },
  guideMeSheet: {
    // The main Guide me's voice ("We highlight each thing to tap"), not a first-person "I".
    subtitle: "Pick something to set up on this asset. We highlight each thing to tap, one step at a time.",
  },
  graphInspector: {
    selectedLink: 'Selected link',
  },
  decommissionSheet: {
    title: 'Decommission',
    cancelA11y: 'Cancel decommissioning',
    reasonLabel: 'Why is it leaving service?',
    outOfServiceFromLabel: 'Out of service from',
    noteLabel: 'Note',
    notePlaceholder: 'What the team should know — e.g. heat exchanger cracked, replacement ordered.',
    noteA11y: 'Decommissioning note',
    makeSafeFirstTitle: 'Make it safe first',
    makeSafeFirstBodyOn_one: 'Raises a job with {{count}} make-safe step as its postcheck. The asset leaves service when that job is verified.',
    makeSafeFirstBodyOn_other: 'Raises a job with {{count}} make-safe steps as its postcheck. The asset leaves service when that job is verified.',
    makeSafeFirstBodyOff: 'No job. The asset leaves service now; add a note saying who decided.',
    makeSafeSwitchA11y: 'Raise a make-safe job before the asset leaves service',
    confirmRaise: 'Raise the make-safe job',
    confirmTakeOut: 'Take out of service now',
  },
  dataQuality: {
    bandComplete: 'Profile complete',
    bandPartial: 'Profile partial',
    bandMissing: 'Details missing',
    title: 'Asset profile',
    subtitleAllComplete_one: 'All {{total}} applicable profile field is complete.',
    subtitleAllComplete_other: 'All {{total}} applicable profile fields are complete.',
    subtitleAddLead: 'Add {{label}} — {{unlock}}.',
    subtitleAddMissing: 'Add the missing structured details to complete this asset profile.',
    addGapA11y: 'Add {{label}} — {{unlock}}',
    applySuggestions_one: 'Apply {{count}} AI suggestion',
    applySuggestions_other: 'Apply {{count}} AI suggestions',
    confidenceMediumLabel: 'Medium confidence',
    confidenceMediumBody: 'The AI is working with limited details on this asset.',
    confidenceLowLabel: 'Low confidence',
    confidenceLowBody: 'This asset has little structured data, so treat the AI output as a starting point.',
    confidenceA11y: '{{label}}. {{body}} Improve data quality.',
    confidenceBodySuffix: '{{body}} Improve data →',
  },
  activitySection: {
    who: 'Who: {{name}}',
    when: 'When: {{when}}',
    refineActivity: 'Refine activity',
    refine: 'Refine',
    searchActivityPlaceholder: 'Search activity…',
    searchActivityA11y: 'Search activity',
    clearSearchA11y: 'Clear search',
    hideSearchA11y: 'Hide search',
    noActivityOnDate: 'No activity on this date',
    noActivityHint: 'Pick another day, or change the refine or search.',
    view: 'View',
    timeline: 'Timeline',
    calendar: 'Calendar',
    status: 'Status',
    all: 'All',
    outstanding: 'Outstanding',
    planned: 'Planned',
    completed: 'Completed',
    inspections: 'Inspections',
    jobs: 'Jobs',
    documents: 'Documents',
  },
  actionsSection: {
    uploadDocumentA11y: 'Upload document',
    uploadDoc: 'Upload doc',
  },
  portfolioGraphPanel: {
    couldNotLinkTitle: 'Could not link',
    createRelationshipFailed: 'Failed to create the relationship.',
    couldNotRemoveTitle: 'Could not remove',
    failed: 'Failed.',
    emptyTitle: 'No assets to visualize',
    emptySub: 'Create your first asset to see the network.',
    useListView: 'Use list view',
  },
  portfolioContextualBar: {
    linkTypeHeader: 'Link type · {{source}} → {{target}}',
    defaultSourceName: 'source',
    defaultTargetName: 'target',
    pickTypeHint: 'Pick a type or use More options for full details.',
    moreOptions: 'More options',
    editOnSource: 'Edit on source',
    criticalityBadge: '{{criticality}} criticality',
    impactsRelated_one: 'Impacts {{count}} related',
    impactsRelated_other: 'Impacts {{count}} related',
    connectFromHere: 'Connect from here',
  },
  portfolioGraphContextRow: {
    exit: 'Exit',
    connect: 'Connect',
  },
  listRow: {
    canRequestWork: 'Can request work',
    readOnly: 'Read-only',
    overdue: 'Overdue',
    next: 'Next',
    nextStepLabel: '{{prefix}}: {{scheduleLabel}} {{time}}',
    recommendedRaiseJob: 'Recommended: Raise job',
    recommendedInspect: 'Recommended: Inspect',
    healthSuffix: '{{status}} health',
    needsAttention: 'needs attention',
    openNextStep: 'Open {{label}}',
    recommendRaiseJobA11y: 'Recommended next action: raise a job',
    recommendInspectA11y: 'Recommended next action: start an inspection',
    directionsTo: 'Directions to {{name}}',
    relationshipsFor: 'Relationships for {{name}}',
  },
  shareSection: {
    invitePending: 'Invite pending',
    inviteRequired: 'Invite required',
    active: 'Active',
    title: 'Shared Contacts',
    subtitle: 'Everyone listed here can open this asset in the shared workspace according to their role and permissions.',
    shareWithContact: 'Share with contact',
    loading: 'Loading shared contacts…',
    empty: 'No contacts have access to this asset yet. Share it with a contact so they can request inspections or propose jobs.',
    linkedContactFallback: 'Linked contact',
    noRelationshipLinked: 'No asset relationship linked',
    collaborationRole: 'Collaboration role: {{role}}',
    collaborationRoleWithStatus: 'Collaboration role: {{role}} · {{status}}',
    canView: 'Can view',
    lockedFeatureName: 'Sharing with contacts',
    canRequestInspection: 'Can request inspection',
    canProposeJob: 'Can propose job',
    yes: 'Yes',
    no: 'No',
    workspaceVisibility: 'Workspace visibility: {{detail}}',
    openRequests: 'Open requests: {{count}}',
    openRequestsWithLast: 'Open requests: {{count}} · Last request {{date}}',
    openRequestsNoneYet: 'Open requests: {{count}} · No requests yet',
    inviteSentResendHint: 'Invite sent. Resend if they did not receive it.',
    inviteSendHint: 'Send invite so they can link their account and access this asset.',
    working: 'Working...',
    resendInvite: 'Resend invite',
    sendInvite: 'Send invite',
    editPermissions: 'Edit permissions',
    revokeAccess: 'Revoke access',
    viewContact: 'View contact',
    viewRequests: 'View requests',
  },
  listSignalPills: {
    riskDefaultLabel: 'Risk',
    overdueJob_one: 'overdue job',
    overdueJob_other: 'overdue jobs',
    complianceLabel: 'Compliance',
  },
  overviewQuickActions: {
    defaultTitle: 'Quick actions',
  },
  imageCarousel: {
    photoPosition: 'photo {{current}} of {{total}}',
    photoSingle: 'photo',
    labeledPosition: '{{label}}, {{position}}',
    viewFullSize: '{{label}}. View full size',
    previousPhoto: 'Previous photo',
    nextPhoto: 'Next photo',
    goToPhoto: 'Go to photo {{current}} of {{total}}',
  },
  imageLightbox: {
    defaultTitle: 'Asset photos',
    closeA11y: 'Close',
  },
  conditionAccordion: {
    a11yLabelExpanded: '{{title}}, expanded',
    a11yLabelCollapsed: '{{title}}, collapsed',
  },
  impactChip: {
    a11yLabel_one: 'This asset feeds {{count}} related asset — view their work',
    a11yLabel_other: 'This asset feeds {{count}} related assets — view their work',
    text_one: 'Feeds {{count}} related asset — issues here can affect their work',
    text_other: 'Feeds {{count}} related assets — issues here can affect their work',
  },
  assetDetailsPanel: {
    roomCounts: 'Room counts',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    kitchens: 'Kitchens',
    livingRooms: 'Living rooms',
    diningRooms: 'Dining rooms',
    utilityRooms: 'Utility rooms',
    garages: 'Garages',
    parkingSpaces: 'Parking spaces',
    amenities: 'Amenities',
    garden: 'Garden',
    driveway: 'Driveway',
    balcony: 'Balcony',
    ensuite: 'Ensuite',
    outbuilding: 'Outbuilding',
    basement: 'Basement',
    loft: 'Loft',
    furnishing: 'Furnishing',
    systems: 'Systems',
    facilityCounts: 'Facility counts',
    units: 'Units',
    toilets: 'Toilets',
    kitchenettes: 'Kitchenettes',
    loadingBays: 'Loading bays',
    lifts: 'Lifts',
    facilityFeatures: 'Facility features',
    reception: 'Reception',
    plantRoom: 'Plant room',
    fireAlarm: 'Fire alarm',
    sprinklers: 'Sprinklers',
    accessControl: 'Access control',
    shutterDoors: 'Shutter doors',
    condition: 'Condition',
    capacity: 'Capacity',
    seatingCapacity: 'Seating capacity',
    loadCapacity: 'Load capacity',
    datesService: 'Dates & service',
    year: 'Year',
    yearPlaceholder: 'e.g. 2024',
    odometer: 'Odometer',
    roadCompliance: 'Road compliance',
    capacityElectrical: 'Capacity & electrical',
    voltage: 'Voltage',
    phase: 'Phase',
    capacityValue: 'Capacity value',
    serviceSchedule: 'Service schedule',
    serviceIntervalDays: 'Service interval (days)',
    details: 'Details',
    coreDetails: 'Core details',
    propertyDetails: 'Property details',
    propertyDetailsHint: 'Choose a property category first to unlock only the relevant sections.',
    retrySavingDetails: 'Retry saving details',
    structuredDetailsFor: 'Structured details for this {{assetType}}.',
    noStructuredDetails: 'No structured details have been confirmed yet.',
    assetProfileDetails: 'Asset profile details',
    coreDetailsConfirmed: 'Core details are confirmed for this asset.',
    hiddenUntilPropertyChosen: 'Room counts, facility details, and AI fields stay hidden until the property path is chosen.',
    unsavedChanges: 'Unsaved changes…',
    saving: 'Saving…',
    saved: 'Saved',
    couldNotSaveChanges: 'Could not save your changes.',
    changesSaveAutomatically: 'Changes save automatically.',
    retry: 'Retry',
    coreFieldsFilled: '{{completed}} of {{total}} core fields filled',
    stillMissing: 'Still missing: {{labels}}',
    applySeededSuggestions_one: 'Apply {{count}} seeded suggestion',
    applySeededSuggestions_other: 'Apply {{count}} seeded suggestions',
    applySeededSuggestionsZero: 'Apply seeded suggestions',
    appliedSuggestions_one: 'Applied {{count}} suggestion — review the fields below; they save automatically.',
    appliedSuggestions_other: 'Applied {{count}} suggestions — review the fields below; they save automatically.',
    noSuggestionsToFill: 'These details already match every seeded suggestion — nothing to fill.',
    lifecycle: 'Lifecycle',
    criticality: 'Criticality',
    compliance: 'Compliance',
    furnishedStatus: 'Furnished status',
    location: 'Location',
    otherCategory: 'Other category',
    subtypeDetailLegacy: 'Subtype detail (legacy)',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    viewQrCode: 'View QR code',
    hideQrCode: 'Hide QR code',
  },
  imageDrawModal: {
    colorRed: 'Red',
    colorAmber: 'Amber',
    colorGreen: 'Green',
    colorWhite: 'White',
    toolDraw: 'Draw',
    toolArrow: 'Arrow',
    toolBox: 'Box',
    toolCircle: 'Circle',
    toolText: 'Text',
    couldNotSaveMarkupTitle: 'Could not save markup',
    couldNotSaveMarkupBody: 'The photo was added without the markup.',
    clearAllMarkupTitle: 'Clear all markup?',
    clearAllMarkupBody: 'This removes every mark on the photo.',
    cancel: 'Cancel',
    clear: 'Clear',
    cancelMarkupA11y: 'Cancel markup',
    doneA11y: 'Done',
    done: 'Done',
    markupTitle: 'Markup',
    labelThisPointPlaceholder: 'Label this point',
    markupTextA11y: 'Markup text',
    addTextA11y: 'Add text',
    add: 'Add',
    cancelTextA11y: 'Cancel text',
    undoLastMarkA11y: 'Undo last mark',
    undo: 'Undo',
    clearAllMarkupA11y: 'Clear all markup',
  },
  qrScanner: {
    enterCodeTitle: 'Enter code',
    enterCodeBody: 'Please paste or type a QR code value.',
    qrCodeTitle: 'QR Code',
    qrCodeValueA11y: 'QR code value',
    webUnavailableMessage: 'Camera scanning is not available on web. Paste a QR code value below or use the app on your phone to scan.',
    pasteOrTypePlaceholder: 'Paste or type QR code value...',
    resolveCode: 'Resolve code',
    cancel: 'Cancel',
    requestingPermission: 'Requesting camera permission...',
    permissionRequiredTitle: 'Camera Permission Required',
    permissionRequiredMessage: 'Camera access is required to scan QR codes. Please enable camera permissions in your device settings.',
    grantPermission: 'Grant Permission',
    typeCodeUnderQrPlaceholder: 'Or type the code printed under the QR…',
    scanQrCodeTitle: 'Scan QR Code',
    closeScannerA11y: 'Close scanner',
    typeCodeUnderQrShortPlaceholder: 'Type the code printed under the QR',
    positionQrHint: 'Position the QR code within the frame',
    backToCameraA11y: 'Back to the camera',
    enterCodeInsteadA11y: 'Enter the code instead',
    backToCamera: 'Back to the camera',
    cantScanEnterCode: 'Can’t scan it? Enter the code instead',
    scanned: 'Scanned',
  },
  measureView: {
    spokenClear: 'Clear',
    spokenDivide: 'Divide',
    spokenMultiply: 'Multiply',
    spokenBackspace: 'Backspace',
    spokenMinus: 'Minus',
    spokenPlus: 'Plus',
    spokenEquals: 'Equals',
    spokenDecimalPoint: 'Decimal point',
    captureReading: 'Capture reading',
  },
  dictateView: {
    stopDictation: 'Stop dictation',
    startDictation: 'Start dictation',
    listening: 'Listening…',
    stopped: 'Stopped',
    tapToTalk: 'Tap to talk',
    speakNaturally: 'Speak naturally — AI will file the right record.',
    transcriptPlaceholder: 'Your transcript will appear here as you speak.',
    clear: 'Clear',
    useTranscript: 'Use transcript',
  },
  dictateCapture: {
    issueDraftLabel: 'Issue draft',
    issueDraftDetail: 'Looks like a defect — Copilot can file an issue.',
    noteLabel: 'Note',
    noteDetail: 'Captured as a plain note attached to the current context.',
  },
  omniCaptureSheet: {
    modePhoto: 'Photo',
    modePhotoHint: 'Snap or pick a photo. Caption auto-suggested.',
    modeDictate: 'Dictate',
    modeDictateHint: 'Talk it through; AI files the right record.',
    modeScan: 'Scan QR',
    modeScanHint: 'Jump to the linked asset.',
    modeMeasure: 'Measure',
    modeMeasureHint: 'Capture a reading or do a quick calc.',
    modeNote: 'Note',
    modeNoteHint: 'Plain-text note attached to context.',
    defaultTitle: 'Capture',
    backA11y: 'Back',
    closeA11y: 'Close',
    forScope: 'For: {{scope}}',
    noteA11y: 'Note',
    notePlaceholder: 'Add a note...',
    saveNoteA11y: 'Save note',
    saveNote: 'Save note',
  },
  workLocationFlag: {
    defaultAssetName: 'the asset',
    locationCheckWaiting: 'Location check waiting',
    recordedAway: 'Recorded away from the asset',
    carriedOutWithDistance: 'This work was carried out {{distance}} from where {{name}} is recorded.',
    carriedOutNoDistance: 'This work was carried out away from where {{name}} is recorded.',
    pendingSuffix: ' The team managing the asset has not answered yet.',
    reviewedSuffix: ' Reviewed: the asset has not moved.',
  },
  what3wordsField: {
    useSuggestion: 'Use {{words}}',
  },
  assetMoveSheet: {
    reasonMoved: 'It moved',
    reasonMovedHint: 'The asset is physically somewhere new',
    reasonCorrected: 'It was wrong',
    reasonCorrectedHint: 'The asset never was where the record said',
    title: 'Move {{assetName}}',
    whatHappened: 'What happened?',
    whereIsItNow: 'Where is it now?',
    whenDidItMove: 'When did it move?',
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last week',
    overAMonthAgo: 'Over a month ago',
    noteOptional: 'Note (optional)',
    notePlaceholder: 'e.g. Relocated to the sub-basement plant room',
    recordTheMove: 'Record the move',
    correctTheLocation: 'Correct the location',
    cancel: 'Cancel',
  },
  locationClaimReview: {
    fieldResponseAssetIsHere: 'The person on site confirmed the asset is there',
    fieldResponseAssetNotHere: 'The person on site said the asset is NOT there',
    fieldResponseUnsure: 'The person on site was not sure',
    fieldResponseDeviceReported: 'A connected device reported the asset from there — nobody was asked',
    defaultAssetName: 'This asset',
    stillWhereWeThinkTitle: 'Is {{name}} still where we think?',
    unknownDistance: 'Unknown distance',
    betweenRecordedAndSource: 'between the recorded location and {{source}}',
    updateAssetLocation: 'Update the asset location',
    hasNotMoved: 'No, it has not moved',
    whyNotMovedTitle: 'Why has it not moved?',
    whyNotMovedMessage: 'This is kept on the inspection or job, so the person who reported it can see what was decided.',
    whyNotMovedPlaceholder: 'e.g. Asset is still in the plant room; the engineer attended the wrong site',
    rejectAndFlag: 'Reject and flag the work',
  },
  locationField: {
    defaultAddressLabel: 'Address',
    searchAddressPlaceholder: 'Search address…',
    pinSavedAccurate: 'Pin saved, accurate to about {{meters}} m',
    pinSaved: 'Pin saved',
    level: 'Level',
    levelIndexPlaceholder: '0 = ground, -2 = basement 2',
    levelName: 'Level name',
    levelNamePlaceholder: 'e.g. Basement 2, Roof',
    depthLabel: 'Depth below ground (metres)',
    depthPlaceholder: 'e.g. 3.2 for a buried main',
    doesItMove: 'Does it move?',
    useCurrentLocation: 'Use current location',
  },
  locationCheckPrompt: {
    isHereTitle: 'Is {{assetName}} here?',
    assetIsHere: 'Yes, the asset is here',
    assetNotHere: 'No, the asset is somewhere else',
    unsure: "I'm not sure",
    explainWithDistance: 'This work was recorded {{distance}} from where {{assetName}} is on file.',
    explainNoDistance: 'This work was recorded away from where {{assetName}} is on file.',
    reassure: 'Your answer goes to the team that manages this asset. Nothing changes until they confirm it.',
  },
  actionPickerHost: {
    share: { title: 'Share an asset', subtitle: 'Choose the asset to share.' },
    report: { title: 'Report an issue', subtitle: 'Choose the asset to report an issue on.' },
    meterReading: { title: 'Record a reading', subtitle: 'Choose the asset the meter belongs to.' },
    maintenancePlan: { title: 'Add a maintenance plan', subtitle: 'Choose the asset the plan is for.' },
    inspection: { title: 'Start an inspection', subtitle: 'Choose the asset to inspect.' },
    job: { title: 'Log a job', subtitle: 'Choose the asset the job is for.' },
  },
  assetDetailScreen: {
    contactInteraction: {
      unknownName: "Unknown",
      approvalReceived: "Approval received",
      reportShared: "Report shared",
    },
    lastInspectionOutcome: {
      inProgress: "Inspection in progress",
      completed: "Last inspection completed",
      failed: "Failed the last inspection",
    },
    kpiInfo: {
      profileA11y: "Details {{score}}% filled in. Opens the details.",
      profilePill: "Details {{score}}% filled in",
      healthA11y: "Operational health: {{status}}",
      noSchedule: "Nothing scheduled",
      doneCount: "Done: {{n}}",
      scheduledCount: "Scheduled: {{n}}",
      overdueCount: "Late: {{n}}",
      noOpenJobs: "No open jobs",
      openJobsBasedOn: "{{open}} of {{total}} jobs on this asset",
      openJobsDescription: "Jobs on this asset that aren’t checked off or cancelled yet. A job waiting for sign-off still counts.",
      complianceBasedOn: "Documents on file: {{n}}",
      complianceGuidance: "Tap the tile to see each document.",
      complianceDescription: "A score from 0 to 100 for the certificates and documents this kind of asset needs, lower as they get close to expiring.",
      riskEmpty: "No inspection yet, so the risk can’t be worked out.",
      riskBasedOn: "Last inspection {{date}}",
      riskGuidance: "Tap the tile to see how the score was worked out.",
      riskDescription: "How likely a problem is, times how bad it would be, each scored 1 to 5 from the last inspection and how important the asset is. 25 is the highest; 15 or more is high.",
      healthBasedOn: "{{open}} open jobs · {{overdue}} late · {{failed}} failed checks · last inspection {{last}}",
      healthEmpty: "No inspection, certificate or job is recorded on this asset yet.",
      healthGuidance: "Tap the tile to see what changed the score and what to do next.",
      healthDescription: "Operational health: a score from 0 to 100 built from certificates, inspection results, open and late jobs, and the asset’s age. 80 or more is Good, 55 to 79 is Watch, below 55 is Poor. The 1–5 inspection condition rating is a separate measure.",
      never: "never",
      noInspectionYet: "No inspection yet",
      nothingYet: "Nothing recorded yet",
      unavailable: "Couldn’t load",
    },
    approver: {
      anyoneInTeam: "Anyone in the team",
      anyoneIn: "Anyone in {{team}}",
    },
    header: {
      subtitle: "{{lifecycle}} · {{site}} · Owner {{owner}}",
      noSite: "No site yet",
    },
    blocked: {
      archivedNoJobs: "Archived assets can’t get new jobs.",
      retiredNoJobs: "Retired assets can’t get new jobs.",
      archivedNoInspections: "Archived assets can’t start new inspections.",
      retiredNoInspections: "Retired assets can’t start new inspections.",
      decommissionedBody: "Bring it back first: tap Recommission at the top of this asset. That starts an inspection, then any jobs it finds.",
      plannedBody: "Put it into service first: tap Commission at the top of this asset. That starts an inspection, then any jobs it finds.",
      archivedBody: "You can still view and edit it. To add inspections or jobs, unarchive it from the ⋯ menu.",
      retiredBody: "You can still read its history, but you can’t add inspections or jobs. An owner or admin can restore it from the ⋯ menu.",
      archivedTitle: "This asset is archived",
      retiredTitle: "This asset is retired",
    },
    commissionCase: {
      returnStep: "Everything is verified. Tap {{label}}.",
      fixStep: "Finish and verify every job the inspection raised. Then you can return it to service.",
      inspectStep: "Next: tap Start the inspection. Jobs from what it finds come after.",
      recommissioningTitle: "Bringing back into service",
      commissioningTitle: "Putting into service",
    },
    teamMove: {
      movedToPersonal: "Moved to Personal. Only you can see it now.",
      movedToTeam: "Moved to {{team}}. Everyone in that team can now see and work on it.",
    },
    knowledgeShare: {
      openLink: "Anyone with the link",
      contact: "Contact",
      wholeLibrary: "Whole library",
      oneItem: "One item",
      failedBody: "Check your connection and try again.",
      failedTitle: "Link not created",
      chooseContactBody: "Tap Choose contact and pick who the link is for.",
      chooseContactTitle: "Choose a contact",
      noMailBody: "The link is copied. Paste it into a message instead.",
      noMailTitle: "No mail app",
      emailBody: "Open this link to read it: {{url}}",
      emailSubject: "Information shared with you",
      done: "Done",
      emailIt: "Email {{name}}",
      copiedBodyEmail: "Tap Email to send it to {{name}} from your mail app, or paste it into any message.",
      copiedBody: "Paste it into a message to {{name}}. Nothing is sent until you do.",
      linkTitle: "Share link",
      copiedTitle: "Link copied",
      hintItem: "Choose who the link is for. Anyone who has the link can open this item, so send it only to them. You can stop a link below at any time.",
      hintLibrary: "Choose who the link is for. Anyone who has the link can open everything in this asset’s knowledge, so send it only to them. You can stop a link below at any time.",
      invalidUrlBody: "Enter the full web address, starting with https://, for example https://example.com/manual.",
      invalidUrlTitle: "Check the web address",
      saving: "Saving…",
      save: "Save",
    },
    loadingDetails: 'Loading asset details...',
    assetNotFound: 'Asset not found',
    loadErrorTitleRetryable: 'We couldn’t load this asset',
    loadErrorTitleFinal: 'This asset can’t be shown',
    assetOptionsA11y: 'Asset options',
    changeApproverA11y: 'Change who approves work on this asset',
    change: 'Change',
    createdBanner: {
      title: 'Asset created',
      subtitle: 'Start the recommended inspection, report an issue, or add optional details.',
      inspectNow: 'Inspect now',
      inspectNowA11y: 'Inspect this asset now',
      reportIssue: 'Report issue',
      reportIssueA11y: 'Report an issue for this asset',
      addDetails: 'Add details',
      addDetailsA11y: 'Add optional asset details',
      share: 'Share',
      shareA11y: 'Share this asset with a contact',
      dismissA11y: 'Dismiss',
    },
    capture: {
      notSavedTitle: 'Capture not saved',
      notFoundBody: 'That capture could not be found. Please capture it again.',
      mismatchBody: 'This capture does not match the current asset.',
      photoAdded: 'Photo added to asset',
      notesUpdated: 'Asset notes updated',
      measurementAdded: 'Measurement added to asset notes',
      notSupportedTitle: 'Capture not supported',
      notSupportedBody: 'QR scan is handled from the scanner, not saved to assets.',
      noPhotoCaptured: 'No photo was captured.',
      signInRequiredForPhotos: 'You must be signed in to save photos.',
      noNoteCaptured: 'No note text was captured.',
      modeNotSupported: 'This capture mode is not supported for assets.',
    },
    tryAgain: 'Please try again.',
    contactsAlerts: {
      pickerCreateLabel: "Create & link contact",
      pickerLinkTitle: "Link a contact",
      pickerShareTitle: "Share with a contact",
      defaultInviterName: "A colleague",
      linkedBody: "{{name}} is now linked to this asset.",
      sharedAndInvitedBody: "Shared with {{name}}. We emailed {{email}} an invite; they see the asset once they accept it.",
      sharedWithBody: "Shared with {{name}}. They can see this asset in AssetWRX now.",
      emailRequiredTitle: 'Email required',
      emailRequiredBody: 'Add an email on this contact before sending an invite.',
      inviteFailedTitle: 'Unable to send invite',
      selectRelationshipTitle: 'Select relationship',
      selectRelationshipBody: 'Choose at least one relationship type before saving.',
      accessSaveFailedTitle: 'Unable to save contact access',
      accessUpdateFailedTitle: 'Unable to update access',
      resendInviteFailed: 'Unable to resend invite.',
      inviteSent: 'Invite sent',
      inviteUpdated: 'Invite updated',
      inviteCreated: 'Invite created',
      inviteEmailSentBody: 'Invite email sent to {{email}}.',
      inviteRefreshedEmailFailedBody: 'Invite refreshed, but email delivery failed. You can retry resend.',
      inviteSavedEmailFailedBody: 'Invite saved for {{email}}. Email could not be sent{{errorSuffix}}.',
      inviteErrorSuffix: ': {{error}}',
      defaultContactName: 'Contact',
      savedTitle: 'Saved',
      sharedWithCountBody_one: 'Shared with {{count}} contact. Send invites from Shared access where needed.',
      sharedWithCountBody_other: 'Shared with {{count}} contacts. Send invites from Shared access where needed.',
      linkedCountBody_one: 'Linked {{count}} contact.',
      linkedCountBody_other: 'Linked {{count}} contacts.',
      linkContactFailed: 'Unable to link contact with the selected relationship types.',
      inviteRequiredTitle: 'Invite required',
      inviteRequiredNoEmailBody: "Access is saved, but this contact has no email, so they can’t be told. Add their email on the contact, then tap Send invite under Shared access.",
      inviteRequiredBody:
        'Shared access is saved. Send a contact invite now so this person can link their account and see the asset.',
      notNow: 'Not now',
      sendInvite: 'Send invite',
      inviteSentAcceptedBody: 'An invite was sent to {{email}}. Once accepted, they can access this shared asset.',
      inviteCreatedDeliveryFailedBody:
        'Invite created for {{email}}, but email delivery failed. You can resend from Shared access.',
      inviteFailedFallback: 'The share was saved, but the invite failed. Please try again from Contacts.',
    },
    lifecycle: {
      standingA11y: "Status: {{label}}",
      locationCorrected: "Location corrected.",
      moveRecorded: "Move recorded. The old place stays in the location history.",
      decommissioningTitle: 'Decommissioning',
      decommissioningDetail: 'Leaves service when the make-safe job is verified{{jobStatusSuffix}}.',
      decommissioningJobStatusSuffix: ' — job is {{status}}',
      startCommissioningFailedTitle: 'Couldn’t start commissioning',
      backInService: 'Back in service',
      returnToServiceFailedTitle: 'Couldn’t return this asset to service',
      openMakeSafeJob: 'Open the make-safe job',
      startInspection: "Start the inspection",
      openInspection: 'Open the inspection',
      createJobsFromFindings: 'Create jobs from findings',
      waiveAndReturn: 'Waive and return to service',
      putIntoService: "Put into service",
      returnToService: "Return to service",
      cancel: 'Cancel',
      cancelCommissioningTitle: 'Cancel commissioning?',
      cancelCommissioningBody: 'The case closes as abandoned. The inspection and any jobs stay as records.',
      keepGoing: 'Keep going',
      cancelCommissioning: 'Cancel commissioning',
      commission: "Commission",
      recommission: "Recommission",
      unarchived: 'Asset unarchived',
      archived: 'Asset archived',
      statusUpdateFailedTitle: 'Unable to update asset status',
      onlyAdminRestoreTitle: 'Only an admin can restore a retired asset',
      onlyAdminRestoreBody: 'Ask a workspace admin to restore it.',
      restoreFromRetiredTitle: 'Restore from retired?',
      restoreFromRetiredBody:
        'The record reopens as out of service. Recommission it — an inspection, then any jobs it raises — to put it back into service.',
      restore: 'Restore',
      restoredOutOfService: 'Restored — out of service until recommissioned',
      restoreFailedTitle: 'Unable to restore asset',
      moveFailedTitle: 'Could not move the asset',
      moveFailedBody: 'The move could not be saved.',
      makeSafeRaised: 'Make-safe job raised — the asset leaves service when it’s verified',
      outOfService: 'Out of service',
      decommissionFailedTitle: 'Couldn’t decommission this asset',
      retired: 'Retired',
      retireFailedTitle: 'Couldn’t retire this asset',
      returnWaiverTitle: 'Return to service with findings unresolved',
      returnWaiverMessage:
        'Say why the asset can go back into service without a job for what the inspection found. This goes on the certificate.',
      returnWaiverPlaceholder: 'e.g. Cosmetic only; scheduled for the summer shutdown.',
      returnToServiceConfirm: 'Return to service',
    },
    errors: {
      generic: 'Error',
      updateFailed: 'Failed to update.',
      deleteAssetFailed: 'Failed to delete asset.',
      saveDetailsFailed: 'Failed to save asset details.',
      removeAccessFailedTitle: 'Unable to remove access',
      removeAccessBody: 'Remove shared workspace access for {{name}}? They will no longer see this asset as shared.',
      removeAccessDefaultName: 'this contact',
      removeAccessTitle: 'Remove access',
      remove: 'Remove',
      couldNotSaveDetailsTitle: 'Could not save asset details',
      syncFailed: 'Sync failed.',
    },
    deleteAsset: {
      cannotDeleteTitle: 'Cannot delete yet',
      cannotDeleteBody:
        'This asset still has open work:\n• {{openInspections}} open inspection(s)\n• {{openJobs}} open job(s)\n• {{openSchedules}} active schedule(s)\n\nClose/complete these first, then delete will be available.',
      confirmWebTitle: 'Delete asset?\n\nThis cannot be undone.',
      confirmTitle: 'Delete asset',
      confirmBody: 'Are you sure? This cannot be undone.',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    cancelledSectionLabel: 'Cancelled',
    readiness: {
      complianceHeadline: 'Compliance — {{posture}}',
      complianceDefaultAction: 'Review compliance signals',
      inspectionOverdue: 'Inspection overdue',
      inspectionDueOn: 'Inspection due {{date}}',
      completeOverdueInspection: 'Complete the overdue inspection',
      prepareAndComplete: 'Prepare and complete on schedule',
      foundationRunInspection: 'Run an inspection to seed health signals',
      foundationLastInspectedAgo: 'Last inspected {{months}} mo ago — refresh',
      foundationRecentLast_one: '{{count}} recent · last {{date}}',
      foundationRecentLast_other: '{{count}} recent · last {{date}}',
      contactsLabel: 'Contacts',
      contactsLinked_one: '{{count}} linked · tap to manage',
      contactsLinked_other: '{{count}} linked · tap to manage',
      contactsAddRecipient: 'Add an owner or report recipient',
      documentsLabel: 'Documents',
      documentsAttached_one: '{{count}} file attached',
      documentsAttached_other: '{{count}} files attached',
      documentsUpload: 'Upload compliance + warranty files',
      relationshipsLabel: 'Relationships',
      relationshipsLinkedReach_one: '{{count}} linked · reach {{reach}}',
      relationshipsLinkedReach_other: '{{count}} linked · reach {{reach}}',
      relationshipsMap: 'Map upstream / downstream assets',
      evidenceLabel: 'Evidence',
    },
    evidenceStatus: {
      loadingText: 'Loading health, compliance, and risk evidence…',
      failedText: 'Health, compliance, and risk evidence could not be loaded.',
      loadingSub: 'Scores will appear only after all required asset records are available.',
      failedSub: 'Pull to refresh. Scores are hidden until the missing records can be retrieved.',
    },
    conditionAccordionTitle: 'Health, compliance & risk (full breakdown)',
    conditionAccordionSummary: 'Scores, drivers, and deep panels — expand when you need the full picture.',
    kpi: {
      labelHealth: 'Health',
      labelRisk: 'Risk',
      labelCompliance: 'Compliance',
      labelOpenJobs: 'Open jobs',
      labelRecent: 'Recent',
      labelNextDue: 'Next due',
      labelDocuments: 'Documents',
      labelFiles: 'Files',
      labelQuotes: 'Quotes',
      labelLinkedJobs: 'Linked jobs',
    },
    fab: {
      shareAsset: 'Share asset',
      shareAssetTooltip: 'Let someone report issues on this asset',
      shareAssetTooltipAccessOnly: 'Give a contact access to this asset',
      shareAssetDescription:
        'Give a contact access to this asset, or open public QR intake, so issues come to you without the reporter needing an account.',
      reportIssue: 'Report issue',
      reportIssueTooltip: 'Report a problem against this asset',
      reportIssueDescription: 'Open a contextual issue brief with this asset, location, and reporter already attached.',
      inspectNow: 'Inspect now',
      inspectNowTooltip: 'Start an inspection against this asset',
      inspectNowDescription: 'Capture condition, readings, photos, and signatures using the asset’s active checklist.',
      addJob: 'Add job',
      addJobTooltip: 'Raise a work order for this asset',
      addJobDescription:
        'Dispatch maintenance, repair, or scheduled service. Pre-populates asset, site, and last inspection findings.',
      recordReading: 'Record Reading',
      recordReadingTooltip: 'Record a meter reading for this asset',
      recordReadingDescription:
        'Enter the number on the meter — miles, hours, cycles. Maintenance plans that count by use measure from the latest reading.',
      addMaintenancePlan: 'Add Maintenance Plan',
      addMaintenancePlanTooltip: 'Schedule work that comes back',
      addMaintenancePlanDescription:
        'A service, test or inspection that repeats — by date, by meter, or whichever falls first. It raises the work itself when it is due.',
      addDocument: 'Add Document',
      addDocumentTooltip: 'Attach a document to this asset',
      addDocumentDescription:
        'Upload manuals, warranties, certificates, drawings, or compliance records. Auto-tagged to this asset.',
      addKnowledge: 'Add Knowledge',
      addKnowledgeTooltip: 'Write a knowledge article for this asset',
      addKnowledgeDescription:
        'Capture know-how, procedures, or notes as a knowledge article — searchable and shareable alongside this asset.',
      moveAsset: 'Move asset',
      moveAssetTooltip: 'Record that this asset is somewhere new',
      moveAssetDescription:
        'Says WHY the position changed and WHEN, so a genuine move reads differently from a correction in the history.',
      relateAsset: 'Relate Asset',
      relateAssetTooltip: 'Link this asset to another in your register',
      relateAssetDescription:
        'Create parent–child, component, or peer relationships. Risk and activity propagate across linked assets.',
      contacts: 'Contacts',
      createContact: 'Create Contact',
      viewContactsTooltip: 'View contacts linked to this asset',
      addContactTooltip: 'Add a contact associated with this asset',
      contactsLinkedDescription: 'Owners, operators, technicians, and stakeholders linked to this asset.',
      addContactDescription: 'Record an owner, operator, technician, contractor, or stakeholder for this asset.',
      addContact: 'Add contact',
      addContactTooltip2: 'Link a contact to this asset',
      conditionReport: "Asset 360",
      conditionReportTooltip: "Asset 360: a report written for the reader you choose. Uses credits.",
      conditionReportDescription:
        'A generated briefing covering condition trends, recurring faults, cost-to-date, compliance status, and recommended next actions.',
      guideMe: 'Guide me',
      guideMeTooltip: 'Walk me through a task on this asset',
      guideMeDescription:
        'Step-by-step guidance: schedule recurring checks, set up a maintenance plan, record a reading, add a document or knowledge, move it, and more.',
    },
    guide: {
      proactiveLabel: 'Schedule recurring checks',
      proactiveHint: 'An inspection that repeats, so wear is caught before it fails.',
      maintenancePlanLabel: 'Set up a maintenance plan',
      maintenancePlanHint: 'Work that comes back by date, by meter, or whichever is first.',
      meterReadingLabel: 'Record a meter reading',
      meterReadingHint: 'Miles, hours or cycles, so plans that count by use stay on time.',
      raiseRequestLabel: 'Report an issue',
      raiseRequestHint: 'Log a problem and choose what should happen next.',
      addDocumentLabel: 'Add a document',
      addDocumentHint: 'Certificates, warranties and manuals, with expiry reminders.',
      knowledgeLabel: 'Add knowledge',
      knowledgeHint: 'A how-to, FAQ or note your team can find later.',
      moveLabel: 'Record a move',
      moveHint: 'Where it is now, and whether it moved or was recorded wrong.',
      teamLabel: 'Move it to a team',
      teamHint: 'So everyone on the team can work on it.',
      relateLabel: 'Link a related asset',
      relateHint: 'A parent, a part, or something it depends on.',
      publicIntakeLabel: 'Let anyone report by QR',
      publicIntakeHint: 'Public intake: report an issue by scanning a code, no login.',
      aiReportLabel: "Prepare an Asset 360 report",
      aiReportHint: "AI writes it from everything known about this asset, for the reader you choose. Uses credits once it is written.",
      decommissionLabel: 'Take it out of service',
      decommissionHint: 'Decommission with a reason and, if it needs it, a make-safe job.',
      commissionLabelPlanned: 'Put it into service',
      commissionLabelOther: 'Bring it back into service',
      commissionHint: 'A commissioning inspection, jobs from what it finds, then back in service.',
      retireLabel: 'Retire it',
      retireHint: 'Close the record for good, with the disposal on file.',
    },
    copilot: {
      openRequests: 'Open requests',
      openInspections: 'Open inspections',
      openJobs: 'Open jobs',
      reviewOpenWork: 'Review open work',
      reviewAsset: 'Review asset',
      suggestNextSteps: 'Suggest next steps',
      automateRenewalWork: 'Automate renewal work',
    },
    overflow: {
      archive: 'Archive',
      unarchive: 'Unarchive',
      changeStatus: "Change status",
      decommission: 'Decommission',
      restoreFromRetired: 'Restore from retired',
      retireAsset: 'Retire asset',
      delete: 'Delete',
      deleteHelpText: 'Delete is available only after all inspections, jobs, and schedules are closed/completed.',
    },
    refineWork: {
      title: 'Refine work',
      status: 'Status',
      all: 'All',
      scheduled: 'Scheduled',
      active: 'Active',
      completed: 'Completed',
    },
    sections: {
      overview: 'Overview',
      details: 'Details',
      maintenance: 'Maintenance',
      work: 'Work',
      reports: "Reports",
      esg: "ESG",
      documents: 'Documents',
      relationships: 'Relationships',
      knowledge: 'Knowledge',
      activity: 'Activity',
      health: 'Health',
      particulars: 'Particulars',
      contacts: 'Contacts',
      linkedAssets: 'Linked assets',
      labelWithCount: '{{label}}, {{count}}',
      articles: 'Articles',
    },
  },
  advancedReport: {
    shareFailedTitle: "Could not save the report",
    shareGenerated: "Written by AI on {{date}}. Check it before you rely on it.",
    shareTitle: "Asset report: {{name}}",
    pdfDocType: "Asset report",
    insightTitle: "Asset report summary",
    heroSub: "AI writes a report from this asset’s inspections, jobs, documents, risk and maintenance history.",
    heroTitle: "Asset report",
    fallbackTitle: "Asset report",
    metaKind: "AI report",
    summaryPlaceholder: "Tap Generate report to see this asset’s risk, health, compliance and what to do next in one place.",
    actionGenerate: "Generate the asset report.",
    generateFailedTitle: "The asset report was not generated",
    analysisHistory: "History",
    sourceGenerated: "Written by AI",
    sourceSetup: "Not generated yet",
  },
  createForm: {
    checkout: {
      syncingBody: "Payment went through. Wait a moment, then tap Create asset again.",
      syncingTitle: "Your plan is almost ready",
      cancelledBody: "Your asset details are still here. Tap Create asset when you are ready.",
      notStartedTitle: "Plan not started",
      cancelledTitle: "Checkout cancelled",
      openFailedBody: "Check your connection and try again.",
      openFailedTitle: "Couldn’t open checkout",
    },
    save: {
      saveWithoutPhotos: "Create without photos",
      cancel: "Cancel",
      photoUploadFailedBody: "Create the asset without photos? You can add them later with Edit.",
      photoUploadFailedTitle: "Photos could not be uploaded",
      photosFailedBody: "The photos could not be uploaded. Open the asset and tap Edit to add them.",
      photosFailedTitle: "Asset created without photos",
      duplicateDecisionBody: "Your choice about the possible duplicate was not saved. You can link them from the asset later.",
      duplicateDecisionTitle: "Asset created",
      partialRelBody: "Links to other assets not saved: {{n}}. Add them again from the asset’s Relationships section.",
      partialRelTitle: "Asset created, some links not saved",
      qrNotLinkedBody: "Open the asset and link the label from its QR section.",
      qrNotLinkedTitle: "Asset created, QR label not linked",
      failedBody: "Check your connection and tap Create asset again. Your details are still here.",
      failedTitle: "Couldn’t create the asset",
      nameRequiredBody: "Give the asset a name, then tap Create asset.",
      nameRequiredTitle: "Type a name",
      signInBody: "Sign in again, then tap Create asset.",
      signInTitle: "Sign in again",
    },
    duplicates: {
      failedBody: "Check your connection and try again.",
      failedTitle: "Couldn’t check for duplicates",
      foundTitle: "These might be the same asset",
      noneBody: "Nothing else matches this name or ID.",
      noneTitle: "No duplicates found",
      needNameBody: "Type the asset name, then check for duplicates.",
      needNameTitle: "Type a name first",
    },
    idHint: "The number on its plate or label. It lets you find the asset by scanning it.",
    useIdFromPhoto: "Use “{{id}}” as the ID or serial",
    readPlateTitle: "Read the plate",
    externalIdOptional: "{{label}} (optional)",
    unnamed: "Unnamed asset",
    dictation: {
      listening: "Listening…",
      heard: "Heard: {{text}}",
      finishing: "Finishing…",
      inserting: "Adding what you said…",
      stopA11y: "Stop dictating",
      dictateA11y: "Dictate the name",
      stop: "Stop",
      dictate: "Dictate",
    },
    footer: {
      creating: "Creating…",
      create: "Create asset",
      needName: "Type a name to start",
      needsPlan: "The next asset needs a paid plan",
      needsPlanHint: "What you have entered is kept while you choose.",
      ready: "Ready to create",
    },
    sectionWhy: {
      details: "Add the make, model and how important it is. You can do this later.",
      identify: "Add a photo and the serial number or barcode so it can be scanned on site.",
      location: "Add the site or address so people can find it.",
      basics: "Name it and pick a type. That’s all you need to create it.",
    },
    location: {
      locationOptional: "Location (optional)",
      propertyAddress: "Property address",
      siteSelected: "Site · {{name}}",
      siteLabel: "Site",
      noSiteBody: "No site is close to where you are. Pick a site from the list, or leave it empty.",
      noSiteTitle: "No site nearby",
      noAddressBody: "We found where you are but not the street address. Type the address instead.",
      noAddressTitle: "No address found",
    },
    photos: {
      summaryCount: "{{used}} of {{max}}",
      countFull: "{{max}} of {{max}}. That is the most you can add.",
      countMore: "{{used}} of {{max}}. You can add {{left}} more.",
      galleryA11y: "Choose from your photos. {{used}} of {{max}} used.",
      cameraA11y: "Take a photo. {{used}} of {{max}} used.",
      mainFullA11y: "Main photo. {{max}} of {{max}} photos added.",
      mainA11y: "Main photo. {{used}} of {{max}} added. Tap to add another.",
      addA11y: "Add photos, up to {{max}}",
      cameraBody: "Allow AssetWRX to use the camera in your phone’s settings, then try again.",
      libraryBody: "Allow AssetWRX to use your photos in your phone’s settings, then try again.",
      permissionTitle: "Allow access",
      limitBody: "You can add up to {{max}} photos.",
      limitTitle: "Photo limit reached",
    },
    suggestion: {
      useA11y: "Use {{label}} as the type",
      dismiss: "No thanks",
      use: "Use this",
      fromPhoto: "From the photo, this looks like: {{label}}",
      looksLike: "Looks like: {{label}}",
    },
    photoIdentify: {
      noMatchBody: "We couldn’t tell what this is from the photo. Try a clearer photo, or pick the type yourself.",
      noMatchTitle: "No match found",
      noCreditsBody: "Your workspace has no AI credits left. Pick the type yourself.",
      failedBody: "Try again, or pick the type yourself.",
      failedTitle: "Couldn’t read the photo",
      a11y: "Find the asset type from the photo",
      busy: "Looking at the photo…",
      button: "Find the type from the photo",
    },
    leaveGuard: {
      keep: "Keep editing",
      leave: "Leave",
      message: "Your new asset is not saved yet. Leave and lose it?",
    },
    namePlaceholder: {
      other: "For example, Stage lighting",
      equipment: "For example, Boiler 3",
      property: "e.g. 14 Oak Street",
      car: "For example, Toyota Camry 2024",
    },
    typeDesc: {
      other: "Everything else",
      equipment: "Machines and tools",
      property: "Buildings and land",
      car: "Vehicles and fleets",
    },
  },
  lifecycleBanner: {
    plannedBody: "Tap Commission to put it into service: an inspection first, then any jobs it finds.",
    decommissionedBody: "Its schedules are paused. Tap Recommission to bring it back into service.",
    archivedBody: "You can still view and edit it. To add inspections or jobs, unarchive it from the ⋯ menu.",
    retiredBody: "You can still read its history, but it takes no new inspections or jobs.",
    since: "Since {{date}}",
  },
  shareReview: {
    rights: {
      view: "Can view this asset",
      viewBody: "They see it in their own account.",
      workBody: "They report problems and follow them to done.",
      jobs: "See jobs",
      jobsBody: "Jobs on this asset and how they are going.",
      inspections: "See inspections",
      inspectionsBody: "Inspection results on this asset.",
      documents: "Open documents",
      documentsBody: "Documents stay private until you turn this on.",
    },
    confirmLink: "Link contact",
    confirmShare: "Share",
    selectContact: "Pick a contact first",
    batchHint: "Contacts selected: {{n}}. The access below applies to all of them.",
  },
  editForm: {
    photoCountNone: "0 of {{max}} photos. All optional.",
    photosHintA11y: "Optional. Up to {{max}} photos.",
    saveFailedBody: "Check your connection and tap Save again. Your changes are still here.",
    saveFailedTitle: "Couldn’t save your changes",
    saved: "Changes saved.",
    partialRelTitle: "Changes saved, some links not saved",
    uploadFailedBody: "Check your connection and tap Save again. Your changes are still here.",
    signInBody: "Sign in again, then tap Save.",
    nameRequiredBody: "Give the asset a name, then tap Save.",
    linkFailedTitle: "Couldn’t mark the duplicate",
    linkedBody: "Both assets now show the link, so you can check them later.",
    linkedTitle: "Marked as possible duplicate",
    openExisting: "Open the other asset",
    improve: "Improve with AI",
    improving: "Improving…",
    improveRationale: "Read the new notes, then tap Use to keep them.",
    improveFailedBody: "Try again, or keep your own words.",
    improveFailedTitle: "Couldn’t improve the description",
    improveNeedsDraftBody: "Type or dictate a short description, then tap Improve with AI.",
    improveNeedsDraftTitle: "Write a few words first",
    improvedTitle: "Improved asset notes",
    notFound: "This asset wasn’t found. It may have been deleted, or you may not have access to it.",
    loadFailed: "Couldn’t load this asset. Check your connection and tap Try again.",
  },
  sharedView: {
    facts: {
      nextVisit: "Next visit: {{date}}",
      jobs: "Jobs: {{n}}",
    },
    requests: {
      title: "Your requests",
      you: "You: {{text}}",
      photo: "Photo",
      unread: "New reply",
    },
    thread: {
      title: "Request",
      loading: "Opening the request…",
      loadFailedTitle: "Couldn’t open this request",
      loadFailed: "Check your connection and tap Try again.",
      showProgress: "Show progress and what you can do",
      hideProgress: "Hide progress",
    },
    records: {
      documents: "Documents",
      jobs: "Jobs",
      inspections: "Inspections",
      no_documents: "No documents on this asset yet.",
      no_jobs: "No jobs on this asset yet.",
      no_inspections: "No inspections on this asset yet.",
      loadFailed: "This could not be loaded. Pull down to try again.",
      openDocument: "Open {{title}}",
      expires: "Expires {{date}}",
      due: "Due {{date}}",
      done: "Done {{date}}",
      inspection: "Inspection",
      inspectionNumbered: "Inspection {{number}}",
      issues: "Issues: {{n}}",
    },
    raiseRequest: "Report a problem",
    sharedWithYou: "Shared with you",
    kpiRelatedJobs: "Related jobs",
    none: "None",
    kpiNextInspection: "Next inspection",
    kpiStatus: "Status",
    permDocuments: "Documents",
    permInspections: "Inspections",
    permJobs: "Jobs",
    accept: "Accept",
    working: "Working…",
    invitation: "Invitation",
    thisAsset: "This asset",
    tryAgain: "Try again",
    checking: "Checking…",
    sharedReadOnly: "Shared · read only",
    readOnly: "Read only",
    refreshFailedBody: "Check your connection and tap Try again.",
    refreshFailedTitle: "Couldn’t refresh",
    stillNoAccessBody: "Your account isn’t linked to this share yet. Accept the invitation in your email, or ask the person who shared it to share it again with your email address.",
    stillNoAccessTitle: "Still no access",
    sharedAccess: "Shared with you",
    pendingAccess: "Waiting for you to accept",
    job: "Job",
    linkedAsset: "Linked asset",
    theirWorkspace: "their workspace",
    aTeamMember: "A team member",
    checkFailed: "We couldn’t check your access to this asset. Check your connection and tap Try again.",
    notScheduled: "Not scheduled",
    accessTimedOut: "Checking your access took too long. Check your connection and tap Try again.",
  },
  retireConfirmWord: "RETIRE",
  knowledgeKind: {
    updatedAgo: "updated {{when}}",
    someone: "A team member",
    pinnedPrefix: "Pinned",
    link: "External link",
    howto: "How-to",
    note: "Note",
    faq: "FAQ",
    file: "File",
  },
  knowledgeTab: {
    searchPlaceholder: 'Search knowledge…',
    uploadDocument: 'Upload document',
    noMatchingArticles: 'No matching articles',
    noArticlesYet: 'No articles yet',
    noMatchHint: 'No articles match the current search or filters.',
    emptyManageHint: 'Add how-tos, links, FAQs, or files so your team can find them on the job.',
    emptyReadHint: 'Nothing matches your search or nothing has been published.',
    loadErrorWithReason: '{{error}}. Check your connection and try again.',
    loadErrorHint: 'Check your connection and try again.',
    newArticle: 'New article',
    editArticle: 'Edit article',
    exactMatch: 'Exact match',
    anyMatchCommaSeparated: 'Any match, comma separated',
    commaSeparated: 'Comma separated',
    polishedDescription: 'Polished description',
    polishedContent: 'Polished content',
    polishFailedTitle: 'Unable to polish',
    polishUnavailable: 'Unable to polish right now.',
    polishReview: 'Review the polished text before applying it.',
    polishDescriptionFailed: 'Could not polish the description.',
    polishContentFailed: 'Could not polish the content.',
    titleRequiredTitle: 'Title required',
    titleRequiredBody: 'Please enter a title.',
    errorTitle: 'Error',
    saveFailed: 'Save failed',
    uploadFailedTitle: 'Upload failed',
    uploadFailedBody: 'Could not upload file',
    deleteTitle: 'Delete article',
    deleteBody: 'Remove “{{title}}”?',
    deleteFailed: 'Delete failed',
    cancel: 'Cancel',
    delete: 'Delete',
  },
  /** components/asset/detail/buildAssetNeedsAttentionRows.ts */
  needsAttention: {
    requestsAwaitingApproval_one: '{{count}} request awaiting approval',
    requestsAwaitingApproval_other: '{{count}} requests awaiting approval',
    requestsAwaitingWork_one: '{{count}} approved request needs work',
    requestsAwaitingWork_other: '{{count}} approved requests need work',
    overdueJobs_one: '{{count}} overdue job',
    overdueJobs_other: '{{count}} overdue jobs',
    inspectionsAwaitingApproval_one: '{{count}} inspection awaiting approval',
    inspectionsAwaitingApproval_other: '{{count}} inspections awaiting approval',
    expiredDocuments_one: '{{count}} expired document',
    expiredDocuments_other: '{{count}} expired documents',
    expiringSoonDocuments_one: '{{count}} document expiring soon',
    expiringSoonDocuments_other: '{{count}} documents expiring soon',
    overdueSchedules_one: '{{count}} overdue scheduled inspection',
    overdueSchedules_other: '{{count}} overdue scheduled inspections',
    unresolvedFindings_one: '{{count}} unresolved inspection finding',
    unresolvedFindings_other: '{{count}} unresolved inspection findings',
    pendingApprovals_one: '{{count}} shared report awaits sign-off',
    pendingApprovals_other: '{{count}} shared reports await sign-off',
    openHighUrgencyJobs_one: '{{count}} open high-urgency job',
    openHighUrgencyJobs_other: '{{count}} open high-urgency jobs',
    failedInspections_one: 'Recent inspection flagged failures',
    failedInspections_other: '{{count}} inspections with failures',
    detail: {
      approveOrDecline: 'Approve or decline',
      createJobOrInspection: 'Create a job or inspection',
      progressOrReschedule: 'Progress or reschedule the work',
      reviewAndApprove: 'Review and approve',
      renewOrReplace: 'Renew or replace files',
      planRenewal: 'Plan renewal',
    },
  },
  conditionTrend: {
    loading: 'Loading completed inspections and condition ratings…',
    loadFailed: 'Completed inspections and condition ratings could not be loaded. Pull to refresh and try again.',
    emptyNoInspections: 'Condition trend appears after the first rated inspection.',
    emptyUnrated_one: '{{count}} completed inspection has no 1–5 condition rating, so there is no trend yet.',
    emptyUnrated_other: '{{count}} completed inspections have no 1–5 condition rating, so there is no trend yet.',
    band: { good: 'Good', fair: 'Fair', poor: 'Poor' },
    latest: '{{percent}}% · {{band}}',
    readingsA11y: 'Condition readings, oldest to newest: {{readings}}',
    readingA11y: '{{percent}} percent {{band}}',
    ratedInspections_one: '{{count}} rated inspection',
    ratedInspections_other: '{{count}} rated inspections',
    oneRated: 'One rated inspection · one more shows the trend',
    down_one: 'Down from {{first}}% to {{last}}% across {{count}} inspection.',
    down_other: 'Down from {{first}}% to {{last}}% across {{count}} inspections.',
    steady_one: 'Steady at {{last}}% across {{count}} inspection.',
    steady_other: 'Steady at {{last}}% across {{count}} inspections.',
    up_one: 'Up from {{first}}% to {{last}}% across {{count}} inspection.',
    up_other: 'Up from {{first}}% to {{last}}% across {{count}} inspections.',
  },
  intelligenceCard: {
    state: {
      stable: 'Stable',
      watch: 'Watch',
      deteriorating: 'Deteriorating',
      action_recommended: 'Action recommended',
      critical: 'Critical',
    },
    strength: {
      early_signal: 'Early signal',
      moderate_evidence: 'Moderate evidence',
      strong_evidence: 'Strong evidence',
    },
    conditionScore: 'Condition {{score}}/100 · {{strength}}',
    dataQuality: 'Data quality: {{warning}}',
    suggestedBy: 'Suggested by {{date}}',
    recommendation: {
      inspect_sooner: 'Inspect before the planned service',
      maintenance_sooner: 'Bring the planned maintenance forward',
      review_interval: 'Review the maintenance interval',
      raise_follow_up: 'Raise follow-up work',
      monitor: 'Record a meter reading to keep the plan honest',
    },
    recordFailedTitle: 'Could not record that',
    dismissFailedTitle: 'Could not dismiss that',
    stillOpenBody: 'The recommendation is still open. Try again.',
  },
  /** lib/documentSubtypeCatalog.ts, by subtype id (read through lib/i18n/uiLabels.ts). */
  documentSubtype: {
    label: {
      gas_safety: 'Gas Safety',
      electrical: 'Electrical',
      fire_safety: 'Fire Safety',
      pat_testing: 'PAT Testing',
      lift: 'Lift (LOLER)',
      legionella: 'Legionella',
      pressure_system: 'Pressure System',
      ppe: 'PPE',
      vehicle_roadworthy: 'Roadworthy (MOT)',
      epc: 'Energy performance (EPC)',
      manufacturer: 'Manufacturer',
      extended: 'Extended',
      service_contract: 'Service Contract',
      regulatory: 'Regulatory',
      audit: 'Audit',
      insurance: 'Insurance',
      manual: 'Manual',
      drawing: 'Drawing',
      photo: 'Photo',
      report: 'Report',
    },
    titleExample: {
      gas_safety: 'e.g. Gas safety certificate',
      electrical: 'e.g. Electrical installation certificate',
      fire_safety: 'e.g. Fire risk assessment',
      pat_testing: 'e.g. PAT test record',
      lift: 'e.g. LOLER thorough examination',
      legionella: 'e.g. Legionella risk assessment',
      pressure_system: 'e.g. Written scheme of examination',
      ppe: 'e.g. PPE inspection record',
      vehicle_roadworthy: 'e.g. MOT certificate',
      epc: 'e.g. Energy performance certificate',
      manufacturer: 'e.g. Manufacturer warranty',
      extended: 'e.g. Extended warranty',
      service_contract: 'e.g. Annual service contract',
      regulatory: 'e.g. Regulatory compliance notice',
      audit: 'e.g. Compliance audit report',
      insurance: 'e.g. Public liability insurance',
      manual: 'e.g. Operating manual',
      drawing: 'e.g. Floor plan drawing',
      photo: 'e.g. Asset condition photo',
      report: 'e.g. Condition survey report',
    },
    titleExampleByType: {
      certificate: 'e.g. Gas safety certificate',
      warranty: 'e.g. Manufacturer warranty',
      compliance: 'e.g. Insurance policy',
      general: 'e.g. Equipment manual',
    },
  },
  retirePreflight: {
    openCase: "Bringing it into or out of service is still in progress — finish or cancel that first",
    openInspections_other: "{{count}} inspections in progress — complete or discard them first",
    openInspections_one: "1 inspection in progress — complete or discard it first",
    openJobs_other: "{{count}} open jobs — complete or cancel them first",
    openJobs_one: "1 open job — complete or cancel it first",
  },
  readinessCard: {
    needAttention_one: "{{count}} needs attention",
    needAttention_other: "{{count}} need attention",
    foundationsInPlace: "Foundations in place",
  },
  documentTakeOver: {
    title: "Validate in their place?",
    body_one: "{{name}} has not validated \"{{title}}\" for {{count}} day. Validate it as the asset team? This is recorded as done on their behalf.",
    body_other: "{{name}} has not validated \"{{title}}\" for {{count}} days. Validate it as the asset team? This is recorded as done on their behalf.",
    keepWaiting: "Keep waiting",
    validate: "Validate",
    note_one: "Validated in place of {{name}} by the asset team after {{count}} day without a response.",
    note_other: "Validated in place of {{name}} by the asset team after {{count}} days without a response.",
  },
  lifecycleCopy: {
    inspectionDone: "Inspection ✓",
    inspectionInProgress: "Inspection in progress",
    inspectionNotStarted: "Inspection not started",
    jobsVerified: "Jobs {{verified}}/{{raised}} verified",
    findingsWaived_one: "{{count}} finding waived",
    findingsWaived_other: "{{count}} findings waived",
    findingsNeedJob_one: "{{count}} finding needs a job",
    findingsNeedJob_other: "{{count}} findings need a job",
    noFindings: "No findings",
    retireNoNewWork: "Takes no new inspections or jobs, ever. History and documents stay readable.",
    retireSharesRevoked_one: "{{count}} share revoked",
    retireSharesRevoked_other: "{{count}} shares revoked",
    retireIntakeOff: "Public intake link switched off",
    retireSchedulesCancelled_one: "{{count}} scheduled inspection cancelled",
    retireSchedulesCancelled_other: "{{count}} scheduled inspections cancelled",
    retireNoLongerBilled: "No longer billed",
    retireHidden: "Hidden from lists, KPIs and risk; listed under Retired",
  },
  complianceSummary: {
    recentInspections_one: "{{count}} inspection completed in the last 30 days",
    recentInspections_other: "{{count}} inspections completed in the last 30 days",
    documentsValid: "All tracked compliance documents are currently valid",
    noOverdueSchedules: "No overdue scheduled inspections",
    noOpenJobs: "No open jobs currently linked to this asset",
    uploadDocuments: "Upload compliance documents (certificates, warranties, or evidence) for this asset",
    renewExpired_one: "Renew {{count}} expired compliance document",
    renewExpired_other: "Renew {{count}} expired compliance documents",
    planRenewals_one: "Plan renewals for {{count}} document expiring soon",
    planRenewals_other: "Plan renewals for {{count}} documents expiring soon",
    establishBaseline: "Complete an inspection to establish a verifiable compliance baseline",
    scheduleNewInspection_one: "Schedule a new inspection — last completed inspection was {{count}} day ago",
    scheduleNewInspection_other: "Schedule a new inspection — last completed inspection was {{count}} days ago",
    completeOverdueSchedules_one: "Complete {{count}} overdue scheduled inspection",
    completeOverdueSchedules_other: "Complete {{count}} overdue scheduled inspections",
    resolveOverdueJobs_one: "Resolve or reschedule {{count}} overdue open job",
    resolveOverdueJobs_other: "Resolve or reschedule {{count}} overdue open jobs",
    reviewUrgentJobs_one: "Review {{count}} high-urgency open job and update status or due dates",
    reviewUrgentJobs_other: "Review {{count}} high-urgency open jobs and update status or due dates",
    addressFindings_one: "Address {{count}} unresolved finding from the latest completed inspection",
    addressFindings_other: "Address {{count}} unresolved findings from the latest completed inspection",
    followUpApprovals_one: "Follow up on {{count}} pending approval",
    followUpApprovals_other: "Follow up on {{count}} pending approvals",
  },
  conditionImpacts: {
    expiredDocumentsLabel_one: "Expired compliance document",
    expiredDocumentsLabel_other: "Expired compliance documents",
    expiredDocumentsInline_one: "expired compliance document",
    expiredDocumentsInline_other: "expired compliance documents",
    expiredDocumentsRationale_one: "{{count}} document has passed its expiry date. Each expired item reduces the score by up to 25 points (capped at 50 total).",
    expiredDocumentsRationale_other: "{{count}} documents have passed their expiry date. Each expired item reduces the score by up to 25 points (capped at 50 total).",
    expiringDocumentsLabel_one: "Document expiring soon",
    expiringDocumentsLabel_other: "Documents expiring soon",
    expiringDocumentsInline_one: "document expiring soon",
    expiringDocumentsInline_other: "documents expiring soon",
    expiringDocumentsRationale_one: "{{count}} document is inside the renewal reminder window before expiry (up to 8 points each, max 24).",
    expiringDocumentsRationale_other: "{{count}} documents are inside the renewal reminder window before expiry (up to 8 points each, max 24).",
    overdueSchedulesLabel_one: "Overdue scheduled inspection",
    overdueSchedulesLabel_other: "Overdue scheduled inspections",
    overdueSchedulesInline_one: "overdue scheduled inspection",
    overdueSchedulesInline_other: "overdue scheduled inspections",
    overdueSchedulesRationale_one: "{{count}} scheduled inspection is marked overdue (12 points each, max 24).",
    overdueSchedulesRationale_other: "{{count}} scheduled inspections are marked overdue (12 points each, max 24).",
    overdueOpenJobsLabel_one: "Overdue open job",
    overdueOpenJobsLabel_other: "Overdue open jobs",
    overdueOpenJobsInline_one: "overdue open job",
    overdueOpenJobsInline_other: "overdue open jobs",
    overdueOpenJobsRationale_one: "{{count}} open job has a due date in the past (10 points each, max 30).",
    overdueOpenJobsRationale_other: "{{count}} open jobs have a due date in the past (10 points each, max 30).",
    highUrgencyJobsLabel_one: "High-urgency open job",
    highUrgencyJobsLabel_other: "High-urgency open jobs",
    highUrgencyJobsInline_one: "high-urgency open job",
    highUrgencyJobsInline_other: "high-urgency open jobs",
    highUrgencyJobsRationale_one: "{{count}} open job is set to high urgency (8 points each, max 24).",
    highUrgencyJobsRationale_other: "{{count}} open jobs are set to high urgency (8 points each, max 24).",
    pendingApprovalsLabel_one: "Report sign-off outstanding",
    pendingApprovalsLabel_other: "Report sign-offs outstanding",
    pendingApprovalsInline_one: "report sign-off outstanding",
    pendingApprovalsInline_other: "report sign-offs outstanding",
    pendingApprovalsRationale_one: "{{count}} shared report has not been signed off by the recipient yet (6 points each, max 18).",
    pendingApprovalsRationale_other: "{{count}} shared reports have not been signed off by the recipient yet (6 points each, max 18).",
    recurringIssuesLabel_one: "Recurring fault",
    recurringIssuesLabel_other: "Recurring faults",
    recurringIssuesInline_one: "recurring fault",
    recurringIssuesInline_other: "recurring faults",
    recurringIssuesRationale_one: "{{count}} fault has failed on more than one of the last {{window}} inspections — the previous repair is not holding (6 points each, max 18).",
    recurringIssuesRationale_other: "{{count}} faults have failed on more than one of the last {{window}} inspections — the previous repair is not holding (6 points each, max 18).",
    inspectionFindingsLabel_one: "Unresolved inspection finding",
    inspectionFindingsLabel_other: "Unresolved inspection findings",
    inspectionFindingsInline_one: "unresolved inspection finding",
    inspectionFindingsInline_other: "unresolved inspection findings",
    inspectionFindingsRationale_one: "The latest completed inspection has {{count}} failing or repair item (4 points each, max 20).",
    inspectionFindingsRationale_other: "The latest completed inspection has {{count}} failing or repair items (4 points each, max 20).",
    noDocumentsLabel: "No documents on file",
    noDocumentsInline: "no documents on file",
    noDocumentsRationale: "No certificates, warranties, or compliance files are linked to this asset. Auditors typically expect evidence on file.",
    noCompletedInspectionLabel: "No completed inspection baseline",
    noCompletedInspectionInline: "no completed inspection baseline",
    noCompletedInspectionRationale: "There is no completed or approved inspection yet, so compliance cannot be verified from field data.",
    staleInspectionLabel: "Last inspection over 90 days ago",
    staleInspectionInline: "last inspection over 90 days ago",
    staleInspectionRationale_one: "The most recent completed inspection was {{count}} day ago. Older evidence increases audit uncertainty.",
    staleInspectionRationale_other: "The most recent completed inspection was {{count}} days ago. Older evidence increases audit uncertainty.",
    recentInspectionsLabel: "Recent inspection activity",
    recentInspectionsInline: "recent inspection activity",
    recentInspectionsRationale_one: "{{count}} inspection was completed in the last 30 days with no overdue schedules or jobs — a positive signal.",
    recentInspectionsRationale_other: "{{count}} inspections were completed in the last 30 days with no overdue schedules or jobs — a positive signal.",
    cleanWorkQueueLabel: "No open work from latest inspection",
    cleanWorkQueueInline: "no open work from latest inspection",
    cleanWorkQueueRationale: "There are no open jobs and no unresolved findings on the latest completed inspection.",
  },
  model: {
    placeTypeLabel: 'What kind of place',
    placeTypeHint: 'A building, floor, room or any other area. Your own kinds of place show here too.',
    customTypeLabel: 'Asset type',
    customTypeNone: 'None',
    vehicleNoParent: 'A vehicle does not sit inside another asset. It keeps a home site instead.',
    sitsInLabel: 'Sits in',
    sitsInHint: 'The place, vehicle or item this sits in.',
    sitsInHintPlace: 'The place this place is part of, such as the floor a room is on.',
    sitsInA11yChange: 'Sits in {{name}}. Change',
    sitsInA11yPick: 'Choose where this sits',
    sitsInNone: 'Not inside anything',
    sitsInClear: 'Take out',
    sitsInPickerTitle: 'Where does it sit?',
    sitsInSearch: 'Search places and assets',
    fieldsLabel: '{{type}} details',
    yes: 'Yes',
    no: 'No',
    datePlaceholder: 'YYYY-MM-DD',
    fieldError: {
      required: 'Fill this in',
      number: 'Enter a number',
      date: 'Enter a date as YYYY-MM-DD',
      choice: 'Pick one of the options',
    },
    fieldsIncompleteTitle: 'Some details are missing',
    fieldsIncompleteBody: 'Fill in the highlighted details, then save again.',
    placementFailedTitle: 'Couldn\'t move it',
    placementFailedBody: 'The asset was saved, but where it sits did not change. Try again from the asset.',
    placementError: {
      vehicle: 'A vehicle does not sit inside another asset. It keeps a home site instead.',
      placeInPlace: 'A place can only sit inside another place.',
      alreadyPlaced: 'This asset already sits somewhere. Move it instead.',
    },
    zonesLabel: 'Zones',
    zonesHint: 'Groups that cut across places, such as a fire zone or a cleaning zone. Separate them with commas. Group rules and rounds can pick by zone.',
    zonesPlaceholder: 'Fire zone 2, North wing',
    placeTypes: {
      property: 'Property',
      building: 'Building',
      wing: 'Wing',
      floor: 'Floor',
      room: 'Room',
      unit: 'Unit',
      ward: 'Ward',
      data_hall: 'Data hall',
      rack: 'Rack',
      plant_room: 'Plant room',
      car_park: 'Parking lot',
      yard: 'Yard',
      grounds: 'Grounds',
      pool: 'Pool',
      gate: 'Gate',
      area: 'Area',
    },
    card: {
      title: 'Where it sits',
      homeTitle: 'Home site',
      noHomeSite: 'No home site yet',
      notInside: 'Not inside another place',
      twoParents: 'This sits in two places: {{names}}. Keep one.',
      keepParent: 'Keep {{name}}',
      contains_one: 'Holds {{count}} item',
      contains_other: 'Holds {{count}} items',
      directlyInside_one: 'Directly inside ({{count}})',
      directlyInside_other: 'Directly inside ({{count}})',
      andMore_one: 'and {{count}} more',
      andMore_other: 'and {{count}} more',
      addPlace: 'Add place inside',
      addEquipment: 'Add equipment here',
      move: 'Move',
      putInside: 'Put inside',
      takeOut: 'Take out',
      placeReport: 'Report for this place',
      zones: 'Zones',
      rollupPlaces_one: '{{count}} place',
      rollupPlaces_other: '{{count}} places',
      rollupEquipment_one: '{{count}} equipment item',
      rollupEquipment_other: '{{count}} equipment items',
      rollupVehicles_one: '{{count}} vehicle',
      rollupVehicles_other: '{{count}} vehicles',
      rollupOther_one: '{{count}} other',
      rollupOther_other: '{{count}} other',
      rollupAtRisk_one: '{{count}} at high risk',
      rollupAtRisk_other: '{{count}} at high risk',
      rollupDueVisits_one: '{{count}} visit due',
      rollupDueVisits_other: '{{count}} visits due',
      rollupOpenJobs_one: '{{count}} open job',
      rollupOpenJobs_other: '{{count}} open jobs',
      rollupSeeWork: 'See all work inside',
      addMany: 'Add many inside',
      startRound: 'Start a round',
      groupRule: 'Add a group rule',
    },
  },
  bulk: {
    buildingTitle: 'Set up a building',
    seriesTitle: 'Add many at once',
    buildingAction: 'Set up a building',
    buildingActionA11y: 'Set up a building at {{site}}',
    buildingIntro: 'Pick a kind of building and how big it is. You see every place, and what it adds to your bill, before anything is made.',
    seriesIntro: 'Add a numbered run of places or items inside {{place}}.',
    presetLabel: 'Kind of building',
    multiUseHint: 'A mixed-use site? Set up each building on its own, each with its own kind.',
    siteLabel: 'Site',
    siteSearch: 'Search sites',
    noSite: 'Pick a site',
    buildingNameLabel: 'Building name',
    buildingNamePlaceholder: 'Building A',
    buildingNameRequired: 'Give the building a name',
    defaultBuildingName: 'Main building',
    floorsLabel: 'Floors',
    firstFloorLabel: 'Floors start at',
    spaceLabel: 'On each floor',
    perFloorLabel: '{{type}} count per floor',
    perSpaceLabel: '{{inside}} count in each {{type}}',
    extrasLabel: 'Also add',
    sitePlacesLabel: 'Shared places on the site',
    sitePlacesHint: 'These sit at site level, not inside the building. Only ones the site does not have yet are shown.',
    addTypesLabel: 'Add the usual asset types',
    addTypesHint: 'Adds {{types}} with their details, if you do not have them yet.',
    seriesKindLabel: 'What to add',
    patternLabel: 'Name pattern',
    patternHint: 'Use # for the number. ## pads to two digits, so Room ## gives Room 01, Room 02.',
    defaultItemPattern: 'Item ##',
    startLabel: 'Start at',
    countLabel: 'How many',
    previewTitle: 'What will be made',
    quoteTitle_one: '{{count}} new asset',
    quoteTitle_other: '{{count}} new assets',
    quoteBilled: 'Every place and item is a billed asset.',
    quoteNow_one: 'You have {{count}} asset now.',
    quoteNow_other: 'You have {{count}} assets now.',
    quoteAfter: 'You will have {{after}} assets.',
    quoteAfterLimit: 'You will have {{after}} of the {{limit}} assets your plan allows.',
    quotePrice: 'Your monthly cost goes from {{before}} to {{after}}.',
    quoteOverLimit: 'That is more than your plan allows ({{limit}} assets). Change your plan first, or make fewer.',
    quoteNeedsPlan: 'Pick a plan before adding more assets.',
    tooMany: 'At most {{max}} at once. Make fewer, or do it in parts.',
    createButton_one: 'Create {{count}} asset',
    createButton_other: 'Create {{count}} assets',
    created_one: '{{count}} asset made',
    created_other: '{{count}} assets made',
    failedTitle: 'Couldn\'t create them',
    failedBody: 'Nothing was made. Check your connection and try again.',
    names: {
      groundFloor: 'Ground floor',
      floor: 'Floor {{n}}',
      space: {
        room: 'Room {{code}}',
        ward: 'Ward {{code}}',
        data_hall: 'Data hall {{n}}',
        gate: 'Gate {{code}}',
        unit: 'Unit {{code}}',
        area: 'Area {{code}}',
      },
      inside: {
        room: 'Room {{parent}}-{{n}}',
        rack: 'Rack {{parent}}-{{n}}',
      },
    },
  },
  presets: {
    names: {
      office_block: 'Office building',
      hotel: 'Hotel',
      hospital: 'Hospital',
      data_centre: 'Data center',
      airport: 'Airport',
      shopping_centre: 'Shopping center',
      school: 'School',
      warehouse: 'Warehouse',
      custom: 'Something else',
    },
    descriptions: {
      office_block: 'Floors of offices, plus a reception and a plant room.',
      hotel: 'Guest rooms on each floor, a reception, restaurant, gym, pools and a plant room.',
      hospital: 'Wards on each floor with rooms inside, a reception and a plant room.',
      data_centre: 'Data halls with racks inside, plant rooms, a yard and a gate.',
      airport: 'Gates on each floor, check-in, a baggage hall and parking.',
      shopping_centre: 'Store units on each floor, a food court and parking.',
      school: 'Classrooms on each floor, a hall, grounds and parking.',
      warehouse: 'Storage areas, an office, a yard and a gate.',
      custom: 'Floors and rooms only. Add your own kinds of place later.',
    },
    extras: {
      reception: 'Reception',
      restaurant: 'Restaurant',
      gym: 'Gym',
      pool: 'Pool',
      plant_room: 'Plant room',
      check_in: 'Check-in',
      baggage_hall: 'Baggage hall',
      food_court: 'Food court',
      hall: 'Hall',
      office: 'Office',
      car_park: 'Parking lot',
      grounds: 'Grounds',
      yard: 'Yard',
      gate: 'Gate',
    },
    types: {
      guest_room: 'Guest room',
      fire_door: 'Fire door',
      lift: 'Elevator',
      escalator: 'Escalator',
      air_handler: 'Air handling unit',
      chiller: 'Chiller',
      boiler: 'Boiler',
      generator: 'Generator',
      ups: 'UPS',
      crac_unit: 'CRAC unit',
      pdu: 'PDU',
      infusion_pump: 'Infusion pump',
      medical_gas_outlet: 'Medical gas outlet',
      baggage_belt: 'Baggage belt',
      jet_bridge: 'Jet bridge',
      dock_door: 'Dock door',
      racking: 'Racking',
    },
    fields: {
      beds: 'Beds',
      accessible: 'Accessible',
      fireRating: 'Fire rating',
      selfClosing: 'Self-closing',
      capacityKg: 'Capacity (kg)',
      floorsServed: 'Floors served',
      riseM: 'Rise (m)',
      airflow: 'Airflow (m³/s)',
      filterSize: 'Filter size',
      refrigerant: 'Refrigerant',
      capacityKw: 'Capacity (kW)',
      fuel: 'Fuel',
      outputKw: 'Output (kW)',
      ratingKva: 'Rating (kVA)',
      batteryDate: 'Battery fitted on',
      ratingA: 'Rating (A)',
      phase: 'Phase',
      serialNumber: 'Serial number',
      nextCalibration: 'Next calibration',
      gas: 'Gas',
      lengthM: 'Length (m)',
      leveller: 'Dock leveler',
      bays: 'Bays',
      loadRatingKg: 'Load rating (kg)',
    },
  },
  valueLife: {
    title: "Value and life (optional)",
    hint: "Used by Asset 360 to show its life, value and what repairs cost against replacing it.",
    installedOn: "Installed on",
    installedOnPlaceholder: "YYYY-MM-DD",
    expectedLife: "Expected life in years",
    expectedLifePlaceholder: "For example 15",
    purchaseCost: "Purchase cost",
    replacementCost: "Replacement cost",
    replacementCostHelper: "What replacing it would cost today.",
    currency: "Currency",
    currencyPlaceholder: "For example GBP",
    invalidTitle: "Check value and life",
    invalidBody: "Some value and life details are not valid. Fix the marked fields or clear them.",
    saveFailedTitle: "Value and life not saved",
    saveFailedBody: "The rest of the asset was saved. Try saving value and life again.",
    error: {
      installedOn: "Use a date like 2019-06-30.",
      expectedLifeYears: "Enter whole years from 1 to 200.",
      purchaseCost: "Enter an amount, like 1250 or 1250.50.",
      replacementCost: "Enter an amount, like 1250 or 1250.50.",
      currency: "Use a three-letter code, like GBP or USD.",
    },
  },
  report360Charts: {
    other: "Other",
    dataQualityA11y: "Data quality {{score}} out of 100, {{band}}",
    measureA11y: "{{label}}: {{score}} out of 100",
    notAvailable: "not available",
    trendEmptyA11y: "{{label}}: no stored figures yet.",
    trendEmpty: "No daily figures stored yet. They build up night by night.",
  },
  report360,
} as const;
